
export default {
  "id": 1,
  "grade": 3,
  "number": 1,
  "title": "日商簿記3級練習問題第1回",
  "questions": [
    {
        "id": 1,
        "number": 1,
        "subNumber": 1,
        "categoryId": 1,
        "content": "商品100円を掛けで仕入れた（三分法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "買掛金:100",
        "kamokus": [
            "未払金",
            "商品",
            "仕入",
            "売掛金",
            "繰越商品",
            "買掛金"
        ]
    },
    {
        "id": 2,
        "number": 2,
        "subNumber": 1,
        "categoryId": 1,
        "content": "商品（原価90円）を120円で掛けで売り上げた（三分法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:120",
        "shiwakeRightAnswer": "売上:120",
        "kamokus": [
            "仕入",
            "未収入金",
            "売掛金",
            "買掛金",
            "売上原価",
            "売上"
        ]
    },
    {
        "id": 3,
        "number": 3,
        "subNumber": 1,
        "categoryId": 1,
        "content": "決算日を迎えた。期首商品棚卸高は10円、期末商品棚卸高は20円であった（三分法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:10  繰越商品:20",
        "shiwakeRightAnswer": "繰越商品:10  仕入:20",
        "kamokus": [
            "買掛金",
            "仕入",
            "未払金",
            "売上原価",
            "商品",
            "繰越商品"
        ]
    },
    {
        "id": 4,
        "number": 4,
        "subNumber": 1,
        "categoryId": 1,
        "content": "商品100円を掛けで仕入れた（売上原価対立法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "商品:100",
        "shiwakeRightAnswer": "買掛金:100",
        "kamokus": [
            "仕入",
            "買掛金",
            "売上原価",
            "商品",
            "未払金",
            "売掛金"
        ]
    },
    {
        "id": 5,
        "number": 5,
        "subNumber": 1,
        "categoryId": 1,
        "content": "商品（原価90円）を120円で掛けで売り上げた（売上原価対立法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:120  売上原価:90",
        "shiwakeRightAnswer": "売上:120  商品:90",
        "kamokus": [
            "商品",
            "売上原価",
            "繰越商品",
            "売上",
            "売掛金",
            "仕入"
        ]
    },
    {
        "id": 6,
        "number": 1,
        "subNumber": 1,
        "categoryId": 2,
        "content": "TO社はA社より割戻しが適用され、同社に対する買掛金100円の2％の支払いが免除され、残額を現金で支払った（三分法）。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "仕入:2  現金:98",
        "kamokus": [
            "売上",
            "現金",
            "仕入",
            "買掛金",
            "受取手数料",
            "売掛金"
        ]
    },
    {
        "id": 7,
        "number": 1,
        "subNumber": 1,
        "categoryId": 3,
        "content": "KO社は広告業を営んでいる。顧客から広告の製作依頼があり、製作スタッフの給料500円と消耗品費100円を当該サービスにかかる費用として仕掛品勘定に振り替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:600",
        "shiwakeRightAnswer": "給料:500  消耗品費:100",
        "kamokus": [
            "材料",
            "消耗品費",
            "役務原価",
            "給料",
            "仕入",
            "仕掛品"
        ]
    },
    {
        "id": 8,
        "number": 2,
        "subNumber": 1,
        "categoryId": 3,
        "content": "KO社は広告業を営んでいる。顧客から広告の製作依頼があり、サービス提供前に顧客から対価の全額2,000円を現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:2000",
        "shiwakeRightAnswer": "前受金:2000",
        "kamokus": [
            "現金",
            "役務収益",
            "売上",
            "前受金",
            "仕掛品",
            "役務原価"
        ]
    },
    {
        "id": 9,
        "number": 3,
        "subNumber": 1,
        "categoryId": 3,
        "content": "KO社は広告業を営んでいる。顧客から広告の製作依頼があり、決算日現在、サービスの70％の提供が完了している。これにともなう役務原価420円を仕掛品勘定から振り替える。なお、サービス提供前に顧客から対価の全額2,000円を受け取っている。",
        "lecture": "",
        "shiwakeLeftAnswer": "前受金:1400  役務原価:420",
        "shiwakeRightAnswer": "役務収益:1400  仕掛品:420",
        "kamokus": [
            "前受金",
            "役務原価",
            "現金",
            "売上",
            "役務収益",
            "仕掛品"
        ]
    },
    {
        "id": 10,
        "number": 1,
        "subNumber": 1,
        "categoryId": 4,
        "content": "X社に対する売掛金100円の回収として送金小切手を受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "送金小切手",
            "売上",
            "未収入金",
            "現金",
            "当座預金",
            "売掛金"
        ]
    },
    {
        "id": 11,
        "number": 1,
        "subNumber": 1,
        "categoryId": 5,
        "content": "水道光熱費100円が当座預金口座から引き落とされた際、10円と記入していたため修正仕訳を行う。",
        "lecture": "",
        "shiwakeLeftAnswer": "水道光熱費:90",
        "shiwakeRightAnswer": "当座預金:90",
        "kamokus": [
            "普通預金",
            "当座預金",
            "定期預金",
            "広告宣伝費",
            "水道光熱費",
            "現金"
        ]
    },
    {
        "id": 12,
        "number": 2,
        "subNumber": 1,
        "categoryId": 5,
        "content": "買掛金100円の支払いのために作成していた小切手が未渡しであった。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "買掛金:100",
        "kamokus": [
            "未渡小切手",
            "買掛金",
            "未払金",
            "普通預金",
            "現金",
            "当座預金"
        ]
    },
    {
        "id": 13,
        "number": 3,
        "subNumber": 1,
        "categoryId": 5,
        "content": "広告宣伝費100円の支払いのために作成していた小切手が未渡しであった。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "未払金:100",
        "kamokus": [
            "買掛金",
            "当座預金",
            "未渡小切手",
            "現金",
            "広告宣伝費",
            "未払金"
        ]
    },
    {
        "id": 14,
        "number": 4,
        "subNumber": 1,
        "categoryId": 5,
        "content": "得意先から当座預金口座に売掛金60円の振り込みがあったが、銀行からの連絡が未達であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:60",
        "shiwakeRightAnswer": "売掛金:60",
        "kamokus": [
            "売掛金",
            "未渡小切手",
            "普通預金",
            "買掛金",
            "当座預金",
            "現金"
        ]
    },
    {
        "id": 15,
        "number": 1,
        "subNumber": 1,
        "categoryId": 6,
        "content": "TO社はA社に対する買掛金100円の支払いとしてさきにX社から受け取っていた約束手形を裏書きして渡した。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "受取手形:100",
        "kamokus": [
            "未払金",
            "買掛金",
            "仕入",
            "支払手形",
            "売掛金",
            "受取手形"
        ]
    },
    {
        "id": 16,
        "number": 2,
        "subNumber": 1,
        "categoryId": 6,
        "content": "A社はTO社に対する売掛金100円について、X社振出の約束手形を裏書譲渡された。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "受取手形:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "支払手形",
            "買掛金",
            "当座預金",
            "売掛金",
            "受取手形",
            "支払手数料"
        ]
    },
    {
        "id": 17,
        "number": 1,
        "subNumber": 1,
        "categoryId": 7,
        "content": "TO社は受け取っていたX社振出の約束手形100円を銀行で割り引き、割引料5円が差し引かれた残額は当座預金口座に入金した。",
        "lecture": "",
        "shiwakeLeftAnswer": "手形売却損:5  当座預金:95",
        "shiwakeRightAnswer": "受取手形:100",
        "kamokus": [
            "貸倒引当金",
            "受取手形",
            "普通預金",
            "当座預金",
            "手形売却損",
            "支払手形"
        ]
    },
    {
        "id": 18,
        "number": 1,
        "subNumber": 1,
        "categoryId": 8,
        "content": "所有するY社振出の約束手形100円が不渡りとなった。",
        "lecture": "",
        "shiwakeLeftAnswer": "不渡手形:100",
        "shiwakeRightAnswer": "受取手形:100",
        "kamokus": [
            "受取手形",
            "貸倒損失",
            "支払手形",
            "貸倒引当金",
            "当座預金",
            "不渡手形"
        ]
    },
    {
        "id": 19,
        "number": 2,
        "subNumber": 1,
        "categoryId": 8,
        "content": "不渡手形（100円）として処理したもののうち、60円は現金で回収したが、残額は回収不能となった。なお、貸倒引当金の残高は0円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:60  貸倒損失:40",
        "shiwakeRightAnswer": "不渡手形:100",
        "kamokus": [
            "現金",
            "貸倒引当金",
            "貸倒引当金繰入",
            "不渡手形",
            "受取手形",
            "貸倒損失"
        ]
    },
    {
        "id": 20,
        "number": 1,
        "subNumber": 1,
        "categoryId": 9,
        "content": "TO社はY社より同社振出の約束手形100円について手形の更改の申し入れを受けたため、これを承諾し、同社振出の約束手形を受け取った。なお、手形の更改にともなう利息10円は新手形の代金に含めて処理する。TO社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "受取手形:110",
        "shiwakeRightAnswer": "受取手形:100  受取利息:10",
        "kamokus": [
            "受取手数料",
            "支払利息",
            "当座預金",
            "受取利息",
            "支払手形",
            "受取手形"
        ]
    },
    {
        "id": 21,
        "number": 2,
        "subNumber": 1,
        "categoryId": 9,
        "content": "TO社はY社より同社振出の約束手形100円について手形の更改の申し入れを受けたため、これを承諾し、同社振出の約束手形を受け取った。なお、手形の更改にともなう利息10円は新手形の代金に含めて処理する。Y社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払手形:100  支払利息:10",
        "shiwakeRightAnswer": "支払手形:110",
        "kamokus": [
            "受取手形",
            "受取利息",
            "現金",
            "支払手形",
            "支払手数料",
            "支払利息"
        ]
    },
    {
        "id": 22,
        "number": 1,
        "subNumber": 1,
        "categoryId": 10,
        "content": "TO社は、A社から土地100円を購入し、代金は約束手形を振り出した。",
        "lecture": "",
        "shiwakeLeftAnswer": "土地:100",
        "shiwakeRightAnswer": "営業外支払手形:100",
        "kamokus": [
            "営業外受取手形",
            "未払金",
            "土地",
            "当座預金",
            "営業外支払手形",
            "現金"
        ]
    },
    {
        "id": 23,
        "number": 2,
        "subNumber": 1,
        "categoryId": 10,
        "content": "A社は、TO社に土地（取得原価100円）を100円で売却し、代金は約束手形で受け取った。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "営業外受取手形:100",
        "shiwakeRightAnswer": "土地:100",
        "kamokus": [
            "建物",
            "営業外支払手形",
            "当座預金",
            "土地",
            "未収入金",
            "営業外受取手形"
        ]
    },
    {
        "id": 24,
        "number": 1,
        "subNumber": 1,
        "categoryId": 11,
        "content": "TO社はX社に対する売掛金100円につき、X社の承諾を得て、電子記録債権の発生記録を行った。",
        "lecture": "",
        "shiwakeLeftAnswer": "電子記録債権:100",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "電子記録債務",
            "電子記録債権",
            "買掛金",
            "売上",
            "売掛金",
            "現金"
        ]
    },
    {
        "id": 25,
        "number": 2,
        "subNumber": 1,
        "categoryId": 11,
        "content": "TO社はX社に対する売掛金100円につき、X社の承諾を得て、電子記録債権の発生記録を行っている。その後、TO社のX社に対する電子記録債権の支払期日が到来し、当座預金口座に入金された。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:100",
        "shiwakeRightAnswer": "電子記録債権:100",
        "kamokus": [
            "当座預金",
            "売掛金",
            "電子記録債務",
            "普通預金",
            "買掛金",
            "電子記録債権"
        ]
    },
    {
        "id": 26,
        "number": 3,
        "subNumber": 1,
        "categoryId": 11,
        "content": "X社はTO社に対する買掛金100円につき、電子記録債務の発生記録を行った。X社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "電子記録債務:100",
        "kamokus": [
            "売掛金",
            "電子記録債務",
            "当座預金",
            "営業外支払手形",
            "電子記録債権",
            "買掛金"
        ]
    },
    {
        "id": 27,
        "number": 4,
        "subNumber": 1,
        "categoryId": 11,
        "content": "X社はTO社に対する買掛金100円につき、電子記録債務の発生記録を行っている。その後、債務の支払期日が到来し、当座預金口座から決済した。X社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "電子記録債務:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "電子記録債権",
            "買掛金",
            "当座預金",
            "普通預金",
            "売掛金",
            "電子記録債務"
        ]
    },
    {
        "id": 28,
        "number": 5,
        "subNumber": 1,
        "categoryId": 11,
        "content": "TO社は電子記録債権100円をA社に95円で売却し、譲渡記録を行った。なお売却代金は当座預金口座に入金された。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:95  電子記録債権売却損:5",
        "shiwakeRightAnswer": "電子記録債権:100",
        "kamokus": [
            "当座預金",
            "電子記録債務",
            "手形売却損",
            "売掛金",
            "電子記録債権",
            "電子記録債権売却損"
        ]
    },
    {
        "id": 29,
        "number": 6,
        "subNumber": 1,
        "categoryId": 11,
        "content": "Ａ社はTO社に土地（取得原価100円）を100円で売却し、TO社の承諾を得て、電子記録債権の発生記録を行った。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "営業外電子記録債権:100",
        "shiwakeRightAnswer": "土地:100",
        "kamokus": [
            "営業外電子記録債権",
            "電子記録債権",
            "営業外電子記録債務",
            "未払金",
            "当座預金",
            "土地"
        ]
    },
    {
        "id": 30,
        "number": 7,
        "subNumber": 1,
        "categoryId": 11,
        "content": "Ａ社はTO社に土地（取得原価100円）を100円で売却し、TO社の承諾を得て、電子記録債権の発生記録を行った。TO社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "土地:100",
        "shiwakeRightAnswer": "営業外電子記録債務:100",
        "kamokus": [
            "土地",
            "電子記録債務",
            "営業外電子記録債権",
            "固定資産売却損",
            "未払金",
            "営業外電子記録債務"
        ]
    },
    {
        "id": 31,
        "number": 1,
        "subNumber": 1,
        "categoryId": 12,
        "content": "TO社はX社に対する売掛金100円を、X社の承諾を得てA社に95円で譲渡した。なお譲渡代金は当座預金口座に入金された。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:95  債権売却損:5",
        "shiwakeRightAnswer": "売掛金:100",
        "kamokus": [
            "売掛金",
            "普通預金",
            "債権売却損",
            "手形売却損",
            "受取手形",
            "当座預金"
        ]
    },
    {
        "id": 32,
        "number": 1,
        "subNumber": 1,
        "categoryId": 13,
        "content": "TO社はX社のA社に対する借入金100円の保証人となった。TO社につき仕訳しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "保証債務見返:100",
        "shiwakeRightAnswer": "保証債務:100",
        "kamokus": [
            "保証債務見返",
            "借入金",
            "当座預金",
            "現金",
            "商品保証引当金",
            "保証債務"
        ]
    },
    {
        "id": 33,
        "number": 2,
        "subNumber": 1,
        "categoryId": 13,
        "content": "X社はA社に対する借入金100円を返済した。なお、TO社はX社のA社に対する借入金100円の保証人である。TO社につき仕訳しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "保証債務:100",
        "shiwakeRightAnswer": "保証債務見返:100",
        "kamokus": [
            "借入金",
            "保証債務",
            "商品保証引当金",
            "当座預金",
            "貸付金",
            "保証債務見返"
        ]
    },
    {
        "id": 34,
        "number": 3,
        "subNumber": 1,
        "categoryId": 13,
        "content": "X社はA社に対する借入金100円につき支払不能となり、代わりに保証人であるTO社が現金で返済した。TO社につき仕訳しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "立替金:100  保証債務:100",
        "shiwakeRightAnswer": "現金:100  保証債務見返:100",
        "kamokus": [
            "現金",
            "保証債務見返",
            "借入金",
            "仮払金",
            "保証債務",
            "立替金"
        ]
    },
    {
        "id": 35,
        "number": 1,
        "subNumber": 1,
        "categoryId": 14,
        "content": "建物780円を購入し、代金は後払いとした。なお、不動産会社に対する手数料20円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物:800",
        "shiwakeRightAnswer": "未払金:780  現金:20",
        "kamokus": [
            "建物",
            "現金",
            "支払手数料",
            "土地",
            "買掛金",
            "未払金"
        ]
    },
    {
        "id": 36,
        "number": 2,
        "subNumber": 1,
        "categoryId": 14,
        "content": "備品800円を購入し、代金は2か月ごとに210円を4回に分けて支払うこととした（前払利息で処理）。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品:800  前払利息:40",
        "shiwakeRightAnswer": "未払金:840",
        "kamokus": [
            "支払利息",
            "未払金",
            "営業外支払手形",
            "建物",
            "前払利息",
            "備品"
        ]
    },
    {
        "id": 37,
        "number": 3,
        "subNumber": 1,
        "categoryId": 14,
        "content": "備品800円を購入し、代金は2か月ごとに210円を4回に分けて支払うこととしている（前払利息で処理済）。その後、第1回目の支払日につき、210円を当座預金口座から支払った。なお、前払利息は定額法によって配分する。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払金:210  支払利息:10",
        "shiwakeRightAnswer": "当座預金:210  前払利息:10",
        "kamokus": [
            "当座預金",
            "前払利息",
            "支払利息",
            "備品",
            "支払手数料",
            "未払金"
        ]
    },
    {
        "id": 38,
        "number": 4,
        "subNumber": 1,
        "categoryId": 14,
        "content": "備品800円を購入し、代金は2か月ごとに210円を4回に分けて支払うこととした（前払利息で40円を計上済み）。その後、決算につき計上している前払利息40円のうち前回の支払日から決算日までの1か月分を支払利息に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払利息:5",
        "shiwakeRightAnswer": "前払利息:5",
        "kamokus": [
            "支払利息",
            "前払利息",
            "未払金",
            "当座預金",
            "減価償却費",
            "備品"
        ]
    },
    {
        "id": 39,
        "number": 5,
        "subNumber": 1,
        "categoryId": 14,
        "content": "備品800円を購入し、代金は2か月ごとに210円を4回に分けて支払うこととした（支払利息で処理）。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品:800  支払利息:40",
        "shiwakeRightAnswer": "未払金:840",
        "kamokus": [
            "備品",
            "未払利息",
            "未払金",
            "前払利息",
            "支払利息",
            "当座預金"
        ]
    },
    {
        "id": 40,
        "number": 6,
        "subNumber": 1,
        "categoryId": 14,
        "content": "備品800円を購入し、代金は2か月ごとに210円を4回に分けて支払うこととしている（支払利息で処理）。その後、備品について、第1回目の支払日につき、210円を当座預金口座から支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払金:210",
        "shiwakeRightAnswer": "当座預金:210",
        "kamokus": [
            "当座預金",
            "支払利息",
            "備品",
            "普通預金",
            "受取利息",
            "未払金"
        ]
    },
    {
        "id": 41,
        "number": 7,
        "subNumber": 1,
        "categoryId": 14,
        "content": "備品800円を購入し、代金は2か月ごとに210円を4回に分けて支払うこととしている（支払利息で40円を計上済み）。その後、決算につき、支払利息（40円）について、5か月分は次期の分なので前払利息に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "前払利息:25",
        "shiwakeRightAnswer": "支払利息:25",
        "kamokus": [
            "前払利息",
            "未払金",
            "受取利息",
            "支払利息",
            "当座預金",
            "未払利息"
        ]
    },
    {
        "id": 42,
        "number": 1,
        "subNumber": 1,
        "categoryId": 15,
        "content": "決算において、当期首に購入した備品（取得原価500円、耐用年数5年、残存価額は取得原価の10％）について定額法により減価償却を行う。なお、記帳方法は直接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:90",
        "shiwakeRightAnswer": "備品:90",
        "kamokus": [
            "備品",
            "備品減価償却累計額",
            "未払金",
            "建物減価償却累計額",
            "固定資産売却損",
            "減価償却費"
        ]
    },
    {
        "id": 43,
        "number": 2,
        "subNumber": 1,
        "categoryId": 15,
        "content": "決算において、第1期期首に購入した備品（取得原価500円）について定率法（償却率は0.4）により減価償却を行う。なお、記帳方法は間接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:200",
        "shiwakeRightAnswer": "備品減価償却累計額:200",
        "kamokus": [
            "減価償却費",
            "建物減価償却累計額",
            "備品減価償却累計額",
            "当座預金",
            "未払金",
            "備品"
        ]
    },
    {
        "id": 44,
        "number": 3,
        "subNumber": 1,
        "categoryId": 15,
        "content": "決算において、備品（取得原価500円、減価償却累計額200円）について、200％定率法によって減価償却を行う。なお、耐用年数は5年で記帳方法は間接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:120",
        "shiwakeRightAnswer": "備品減価償却累計額:120",
        "kamokus": [
            "備品減価償却累計額",
            "固定資産売却損",
            "減価償却費",
            "消耗品費",
            "備品",
            "建物減価償却累計額"
        ]
    },
    {
        "id": 45,
        "number": 4,
        "subNumber": 1,
        "categoryId": 15,
        "content": "決算において、車両運搬具（取得原価2,000円）について、生産高比例法によって減価償却を行う。この車両運搬具の可能総走行距離は1,000km、当期走行距離は150km、残存価額は取得原価の10％、記帳方法は間接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:270",
        "shiwakeRightAnswer": "車両運搬具減価償却累計額:270",
        "kamokus": [
            "減価償却費",
            "車両運搬具",
            "備品減価償却累計額",
            "支払リース料",
            "当座預金",
            "車両運搬具減価償却累計額"
        ]
    },
    {
        "id": 46,
        "number": 1,
        "subNumber": 1,
        "categoryId": 16,
        "content": "8月31日に備品（取得原価500円、減価償却累計額200円）を280円で売却し、代金は来月末日に受け取ることにした。この備品は定率法（償却率0.4）で償却しており、間接法によって記帳している。なお、当社の決算日は年1回、3月31日である。",
        "lecture": "",
        "shiwakeLeftAnswer": "未収入金:280  備品減価償却累計額:200  減価償却費:50",
        "shiwakeRightAnswer": "備品:500  固定資産売却益:30",
        "kamokus": [
            "備品減価償却累計額",
            "備品",
            "減価償却費",
            "固定資産売却損",
            "未収入金",
            "固定資産売却益"
        ]
    },
    {
        "id": 47,
        "number": 1,
        "subNumber": 1,
        "categoryId": 17,
        "content": "当期首において、車両（取得原価3,000円、減価償却累計額1,800円、記帳方法は間接法）を1,500円で下取りに出し、新たに4,000円の車両を購入した。なお、差額の2,500円は翌月末日に支払うこととした。",
        "lecture": "",
        "shiwakeLeftAnswer": "車両運搬具:4000  車両運搬具減価償却累計額:1800",
        "shiwakeRightAnswer": "車両運搬具:3000  固定資産売却益:300  未払金:2500",
        "kamokus": [
            "車両運搬具減価償却累計額",
            "固定資産売却益",
            "車両運搬具",
            "当座預金",
            "固定資産売却損",
            "未払金"
        ]
    },
    {
        "id": 48,
        "number": 1,
        "subNumber": 1,
        "categoryId": 18,
        "content": "当期首において、備品（取得原価500円、減価償却累計額360円、記帳方法は間接法）を除却した。なお、除却資産の処分価額は100円と見積もられた。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品減価償却累計額:360  貯蔵品:100  固定資産除却損:40",
        "shiwakeRightAnswer": "備品:500",
        "kamokus": [
            "備品",
            "固定資産除却損",
            "固定資産売却益",
            "減価償却費",
            "備品減価償却累計額",
            "貯蔵品"
        ]
    },
    {
        "id": 49,
        "number": 2,
        "subNumber": 1,
        "categoryId": 18,
        "content": "当期首において、備品（取得原価500円、減価償却累計額360円、記帳方法は間接法）を廃棄した。なお、廃棄費用50円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品減価償却累計額:360  固定資産廃棄損:190",
        "shiwakeRightAnswer": "備品:500  現金:50",
        "kamokus": [
            "固定資産廃棄損",
            "備品",
            "現金",
            "固定資産除却損",
            "貯蔵品",
            "備品減価償却累計額"
        ]
    },
    {
        "id": 50,
        "number": 1,
        "subNumber": 1,
        "categoryId": 19,
        "content": "建物の新築のため、建設会社と500円の請負金額で契約し、着手金100円を小切手を振り出して支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "建設仮勘定:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "当座預金",
            "前払金",
            "建物",
            "現金",
            "前受金",
            "建設仮勘定"
        ]
    },
    {
        "id": 51,
        "number": 2,
        "subNumber": 1,
        "categoryId": 19,
        "content": "建物が完成し引き渡しを受けたので、契約金額500円のうち、契約時に支払った着手金100円を差し引いた400円を小切手を振り出して支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物:500",
        "shiwakeRightAnswer": "建設仮勘定:100  当座預金:400",
        "kamokus": [
            "建設仮勘定",
            "送金小切手",
            "当座預金",
            "支払手形",
            "前払金",
            "建物"
        ]
    },
    {
        "id": 52,
        "number": 1,
        "subNumber": 1,
        "categoryId": 20,
        "content": "建物の改良と修繕を行い、代金500円は小切手を振り出して支払った。このうち300円は改良のための支出である。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物:300  修繕費:200",
        "shiwakeRightAnswer": "当座預金:500",
        "kamokus": [
            "建物",
            "現金",
            "修繕引当金",
            "修繕費",
            "建設仮勘定",
            "当座預金"
        ]
    },
    {
        "id": 53,
        "number": 1,
        "subNumber": 1,
        "categoryId": 21,
        "content": "当期首に建物（取得原価1,000円、減価償却累計額300円、記帳方法は間接法）が火災により焼失した。この建物には保険が付されていない。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物減価償却累計額:300  火災損失:700",
        "shiwakeRightAnswer": "建物:1000",
        "kamokus": [
            "火災損失",
            "建物減価償却累計額",
            "未収入金",
            "商品保証引当金",
            "建物",
            "未決算"
        ]
    },
    {
        "id": 54,
        "number": 2,
        "subNumber": 1,
        "categoryId": 21,
        "content": "当期首に建物（取得原価1,000円、減価償却累計額300円、記帳方法は間接法）が火災により焼失した。この建物には800円の火災保険が付されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物減価償却累計額:300  未決算:700",
        "shiwakeRightAnswer": "建物:1000",
        "kamokus": [
            "建物減価償却累計額",
            "建物",
            "未決算",
            "未収入金",
            "火災損失",
            "減価償却費"
        ]
    },
    {
        "id": 55,
        "number": 3,
        "subNumber": 1,
        "categoryId": 21,
        "content": "当期首に建物（取得原価1,000円、減価償却累計額300円、記帳方法は間接法）が火災により焼失した。なお、建物には600円の火災保険が付されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "建物減価償却累計額:300  未決算:600  火災損失:100",
        "shiwakeRightAnswer": "建物:1000",
        "kamokus": [
            "火災損失",
            "未収入金",
            "建物",
            "建設仮勘定",
            "未決算",
            "建物減価償却累計額"
        ]
    },
    {
        "id": 56,
        "number": 4,
        "subNumber": 1,
        "categoryId": 21,
        "content": "当期首に建物（取得原価1,000円、減価償却累計額300円、記帳方法は間接法）が火災により焼失したため、建物と減価償却累計額との差額を未決算として処理している（適正に処理済）。その後、保険会社より保険金500円を支払う旨の連絡を受けた。",
        "lecture": "",
        "shiwakeLeftAnswer": "未収入金:500  火災損失:200",
        "shiwakeRightAnswer": "未決算:700",
        "kamokus": [
            "保険差益",
            "火災損失",
            "建物減価償却累計額",
            "未決算",
            "当座預金",
            "未収入金"
        ]
    },
    {
        "id": 57,
        "number": 5,
        "subNumber": 1,
        "categoryId": 21,
        "content": "当期首に建物（取得原価1,000円、減価償却累計額300円、記帳方法は間接法）が火災により焼失したため、建物と減価償却累計額との差額を未決算として処理している（適正に処理済）。その後、保険会社より保険金800円を支払う旨の連絡を受けた。",
        "lecture": "",
        "shiwakeLeftAnswer": "未収入金:800",
        "shiwakeRightAnswer": "未決算:700  保険差益:100",
        "kamokus": [
            "未収入金",
            "当座預金",
            "未決算",
            "火災損失",
            "建設仮勘定",
            "保険差益"
        ]
    },
    {
        "id": 58,
        "number": 1,
        "subNumber": 1,
        "categoryId": 22,
        "content": "TO社は、国から国庫補助金400円を受け取り、当座預金口座に入金した。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:400",
        "shiwakeRightAnswer": "国庫補助金受増益:400",
        "kamokus": [
            "備品",
            "国庫補助金受増益",
            "普通預金",
            "固定資産圧縮損",
            "未収入金",
            "当座預金"
        ]
    },
    {
        "id": 59,
        "number": 2,
        "subNumber": 1,
        "categoryId": 22,
        "content": "TO社は、先月に受け取った国庫補助金400円に自己資金600円を加えて備品1,000円を取得し、代金は小切手を振り出して支払った。なお、備品については補助金に相当する額の圧縮記帳（直接減額方式）を行った。",
        "lecture": "",
        "shiwakeLeftAnswer": "備品:1000  固定資産圧縮損:400",
        "shiwakeRightAnswer": "当座預金:1000  備品:400",
        "kamokus": [
            "固定資産圧縮損",
            "当座預金",
            "備品",
            "備品減価償却累計額",
            "現金",
            "国庫補助金受増益"
        ]
    },
    {
        "id": 60,
        "number": 1,
        "subNumber": 1,
        "categoryId": 23,
        "content": "当期首（4月1日）にリース期間：5年間、見積現金購入価額：500円、年間リース料：120円（毎年3月31日）という条件で、備品についてリース契約を結んだ（ファイナンス・リース取引）。なお、当社では利子込み法で処理している。",
        "lecture": "",
        "shiwakeLeftAnswer": "リース資産:600",
        "shiwakeRightAnswer": "リース債務:600",
        "kamokus": [
            "支払リース料",
            "備品",
            "現金",
            "リース債務",
            "支払利息",
            "リース資産"
        ]
    },
    {
        "id": 61,
        "number": 2,
        "subNumber": 1,
        "categoryId": 23,
        "content": "当期首（4月1日）にリース期間：5年間、見積現金購入価額：500円、年間リース料：120円（毎年3月31日）という条件で、備品についてリース契約を結んでいる（ファイナンス・リース取引）。その後、３月31日になったので、リース料を現金で支払った。なお、当社では利子込み法で処理している。",
        "lecture": "",
        "shiwakeLeftAnswer": "リース債務:120",
        "shiwakeRightAnswer": "現金:120",
        "kamokus": [
            "リース債務",
            "支払利息",
            "リース資産",
            "現金",
            "支払リース料",
            "当座預金"
        ]
    },
    {
        "id": 62,
        "number": 3,
        "subNumber": 1,
        "categoryId": 23,
        "content": "3月31日。決算日において、リース資産（計上価額600円）について定額法（残存価額はゼロ、耐用年数は5年）で減価償却を行う。なお、記帳方法は間接法である。",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:120",
        "shiwakeRightAnswer": "リース資産減価償却累計額:120",
        "kamokus": [
            "リース資産",
            "リース債務",
            "リース資産減価償却累計額",
            "支払リース料",
            "支払利息",
            "減価償却費"
        ]
    },
    {
        "id": 63,
        "number": 4,
        "subNumber": 1,
        "categoryId": 23,
        "content": "当期首（4月1日）にリース期間：5年間、見積現金購入価額：500円、年間リース料：120円（毎年3月31日）という条件で、備品についてリース契約を結んだ（ファイナンス・リース取引）。なお、当社では利子抜き法で処理している。",
        "lecture": "",
        "shiwakeLeftAnswer": "リース資産:500",
        "shiwakeRightAnswer": "リース債務:500",
        "kamokus": [
            "支払リース料",
            "減価償却費",
            "リース資産",
            "支払利息",
            "未払金",
            "リース債務"
        ]
    },
    {
        "id": 64,
        "number": 5,
        "subNumber": 1,
        "categoryId": 23,
        "content": "当期首（4月1日）にリース期間：5年間、見積現金購入価額：500円、年間リース料：120円（毎年3月31日）という条件で、備品についてリース契約を結んでいる（ファイナンス・リース取引）。その後、３月31日になったので、リース料を現金で支払った。なお、当社では利子抜き法で処理している。",
        "lecture": "",
        "shiwakeLeftAnswer": "リース債務:100  支払利息:20",
        "shiwakeRightAnswer": "現金:120",
        "kamokus": [
            "リース債務",
            "支払リース料",
            "支払利息",
            "当座預金",
            "普通預金",
            "現金"
        ]
    },
    {
        "id": 65,
        "number": 1,
        "subNumber": 1,
        "categoryId": 24,
        "content": "当期首（4月1日）にリース期間：5年間年間リース料：120円（毎年3月31日）という条件でリース取引（オペレーティング・リース取引）を開始している。3月31日となり、リース料を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払リース料:120",
        "shiwakeRightAnswer": "現金:120",
        "kamokus": [
            "現金",
            "リース債務",
            "普通預金",
            "支払利息",
            "リース資産",
            "支払リース料"
        ]
    },
    {
        "id": 66,
        "number": 1,
        "subNumber": 1,
        "categoryId": 25,
        "content": "特許権を700円で取得し、登録料100円とともに小切手を振り出して支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "特許権:800",
        "shiwakeRightAnswer": "当座預金:800",
        "kamokus": [
            "特許権償却",
            "現金",
            "当座預金",
            "支払手数料",
            "研究開発費",
            "特許権"
        ]
    },
    {
        "id": 67,
        "number": 2,
        "subNumber": 1,
        "categoryId": 25,
        "content": "決算において、特許権800円を償却期間8年で償却する。",
        "lecture": "",
        "shiwakeLeftAnswer": "特許権償却:100",
        "shiwakeRightAnswer": "特許権:100",
        "kamokus": [
            "備品減価償却累計額",
            "特許権",
            "未払金",
            "当座預金",
            "減価償却費",
            "特許権償却"
        ]
    },
    {
        "id": 68,
        "number": 1,
        "subNumber": 1,
        "categoryId": 26,
        "content": "当期首に自社利用目的のソフトウェア500円を購入し、現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "ソフトウェア:500",
        "shiwakeRightAnswer": "現金:500",
        "kamokus": [
            "研究開発費",
            "現金",
            "支払手数料",
            "ソフトウェア",
            "備品",
            "特許権"
        ]
    },
    {
        "id": 69,
        "number": 2,
        "subNumber": 1,
        "categoryId": 26,
        "content": "当期首に自社利用目的のソフトウェア500円を購入している。決算において、そのソフトウェアを利用可能期間5年で償却する。",
        "lecture": "",
        "shiwakeLeftAnswer": "ソフトウェア償却:100",
        "shiwakeRightAnswer": "ソフトウェア:100",
        "kamokus": [
            "ソフトウェア",
            "減価償却費",
            "研究開発費",
            "支払手数料",
            "特許権償却",
            "ソフトウェア償却"
        ]
    },
    {
        "id": 70,
        "number": 1,
        "subNumber": 1,
        "categoryId": 27,
        "content": "もっぱら研究・開発のために使用する器具・装置を100円で購入し、小切手を振り出して支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "研究開発費:100",
        "shiwakeRightAnswer": "当座預金:100",
        "kamokus": [
            "研究開発費",
            "備品",
            "未払金",
            "ソフトウェア",
            "当座預金",
            "特許権"
        ]
    },
    {
        "id": 71,
        "number": 1,
        "subNumber": 1,
        "categoryId": 28,
        "content": "売買目的でN社株式を＠10円で20株購入し、代金は購入手数料10円とともに後日支払うこととした。",
        "lecture": "",
        "shiwakeLeftAnswer": "売買目的有価証券:210",
        "shiwakeRightAnswer": "未払金:210",
        "kamokus": [
            "未払金",
            "支払手数料",
            "満期保有目的債券",
            "有価証券売却益",
            "支払利息",
            "売買目的有価証券"
        ]
    },
    {
        "id": 72,
        "number": 2,
        "subNumber": 1,
        "categoryId": 28,
        "content": "保有するN社株式について、配当金領収証50円を受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:50",
        "shiwakeRightAnswer": "受取配当金:50",
        "kamokus": [
            "当座預金",
            "売買目的有価証券",
            "受取配当金",
            "支払利息",
            "有価証券評価益",
            "現金"
        ]
    },
    {
        "id": 73,
        "number": 3,
        "subNumber": 1,
        "categoryId": 28,
        "content": "売買目的で保有するN社株式10株（帳簿価額は210円）を1株あたり20円で売却し、代金は現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:200  有価証券売却損:10",
        "shiwakeRightAnswer": "売買目的有価証券:210",
        "kamokus": [
            "現金",
            "有価証券売却損",
            "有価証券売却益",
            "有価証券評価損",
            "受取配当金",
            "売買目的有価証券"
        ]
    },
    {
        "id": 74,
        "number": 4,
        "subNumber": 1,
        "categoryId": 28,
        "content": "売買目的で保有するN社株式10株（帳簿価額は210円）を1株あたり25円で売却し、代金は現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:250",
        "shiwakeRightAnswer": "売買目的有価証券:210  有価証券売却益:40",
        "kamokus": [
            "有価証券売却益",
            "現金",
            "有価証券売却損",
            "売買目的有価証券",
            "当座預金",
            "支払手数料"
        ]
    },
    {
        "id": 75,
        "number": 5,
        "subNumber": 1,
        "categoryId": 28,
        "content": "売買目的で保有するN社株式（帳簿価額は210円）を250円で売却し、売却手数料10円を差し引いた残高は現金で受け取った。なお、売却手数料は支払手数料勘定で処理すること。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:240  支払手数料:10",
        "shiwakeRightAnswer": "売買目的有価証券:210  有価証券売却益:40",
        "kamokus": [
            "当座預金",
            "有価証券売却損",
            "売買目的有価証券",
            "支払手数料",
            "有価証券売却益",
            "現金"
        ]
    },
    {
        "id": 76,
        "number": 6,
        "subNumber": 1,
        "categoryId": 28,
        "content": "売買目的で保有するN社株式（帳簿価額は210円）を250円で売却し、売却手数料10円を差し引いた残高は現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:240",
        "shiwakeRightAnswer": "売買目的有価証券:210  有価証券売却益:30",
        "kamokus": [
            "売買目的有価証券",
            "未収入金",
            "現金",
            "有価証券売却益",
            "満期保有目的債券",
            "有価証券売却損"
        ]
    },
    {
        "id": 77,
        "number": 1,
        "subNumber": 1,
        "categoryId": 29,
        "content": "売買目的で額面1,000円のR社社債を額面100円につき95円で購入し、代金は購入手数料10円とともに後日支払うこととした。",
        "lecture": "",
        "shiwakeLeftAnswer": "売買目的有価証券:960",
        "shiwakeRightAnswer": "未払金:960",
        "kamokus": [
            "支払手数料",
            "売買目的有価証券",
            "満期保有目的債券",
            "未払金",
            "受取利息",
            "現金"
        ]
    },
    {
        "id": 78,
        "number": 2,
        "subNumber": 1,
        "categoryId": 29,
        "content": "所有するR社社債について、社債利札10円の期限が到来した。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:10",
        "shiwakeRightAnswer": "有価証券利息:10",
        "kamokus": [
            "現金",
            "支払利息",
            "売買目的有価証券",
            "満期保有目的債券",
            "当座預金",
            "有価証券利息"
        ]
    },
    {
        "id": 79,
        "number": 3,
        "subNumber": 1,
        "categoryId": 29,
        "content": "売買目的で保有するR社社債について、額面1,000円（帳簿価額960円）を額面100円につき97円で売却し、代金は現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:970",
        "shiwakeRightAnswer": "売買目的有価証券:960  有価証券売却益:10",
        "kamokus": [
            "満期保有目的債券",
            "有価証券利息",
            "有価証券売却益",
            "有価証券売却損",
            "売買目的有価証券",
            "現金"
        ]
    },
    {
        "id": 80,
        "number": 4,
        "subNumber": 1,
        "categoryId": 29,
        "content": "9月18日。TO社はA社に売買目的で所有するR社社債（額面金額1,000円、年利率7.3％、利払日は6月末日と12月末日、帳簿価額960円）を額面100円につき97円で売却し、代金は端数利息とともに現金で受け取った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:986",
        "shiwakeRightAnswer": "売買目的有価証券:960  有価証券売却益:10  有価証券利息:16",
        "kamokus": [
            "現金",
            "売買目的有価証券",
            "満期保有目的債券",
            "有価証券利息",
            "有価証券売却損",
            "有価証券売却益"
        ]
    },
    {
        "id": 81,
        "number": 5,
        "subNumber": 1,
        "categoryId": 29,
        "content": "9月18日。A社はTO社から売買目的でR社社債（額面金額1,000円、年利率7.3％、利払日は6月末日と12月末日）を額面100円につき97円で購入し、代金は端数利息とともに現金で支払った。A社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "売買目的有価証券:970  有価証券利息:16",
        "shiwakeRightAnswer": "現金:986",
        "kamokus": [
            "有価証券利息",
            "満期保有目的債券",
            "現金",
            "有価証券売却損",
            "有価証券売却益",
            "売買目的有価証券"
        ]
    },
    {
        "id": 82,
        "number": 1,
        "subNumber": 1,
        "categoryId": 30,
        "content": "決算日における売買目的有価証券（帳簿価額500円）の時価は450円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "有価証券評価損:50",
        "shiwakeRightAnswer": "売買目的有価証券:50",
        "kamokus": [
            "現金",
            "有価証券売却損",
            "有価証券売却益",
            "満期保有目的債券",
            "売買目的有価証券",
            "有価証券評価損"
        ]
    },
    {
        "id": 83,
        "number": 2,
        "subNumber": 1,
        "categoryId": 30,
        "content": "決算日における売買目的有価証券（帳簿価額500円）の時価は520円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "売買目的有価証券:20",
        "shiwakeRightAnswer": "有価証券評価益:20",
        "kamokus": [
            "売買目的有価証券",
            "有価証券売却益",
            "有価証券利息",
            "有価証券売却損",
            "満期保有目的債券",
            "有価証券評価益"
        ]
    },
    {
        "id": 84,
        "number": 3,
        "subNumber": 1,
        "categoryId": 30,
        "content": "決算日、当期首（×1年4月1日）に満期保有目的で額面100円あたり97円で購入したR社社債（額面1,000円、満期日は×4年3月31日）について償却原価法（定額法）を適用する。",
        "lecture": "",
        "shiwakeLeftAnswer": "満期保有目的債券:10",
        "shiwakeRightAnswer": "有価証券利息:10",
        "kamokus": [
            "有価証券評価益",
            "売買目的有価証券",
            "支払利息",
            "有価証券利息",
            "現金",
            "満期保有目的債券"
        ]
    },
    {
        "id": 85,
        "number": 4,
        "subNumber": 1,
        "categoryId": 30,
        "content": "決算日におけるその他有価証券（帳簿価額800円）の時価は750円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "その他有価証券評価差額金:50",
        "shiwakeRightAnswer": "その他有価証券:50",
        "kamokus": [
            "その他有価証券評価差額金",
            "満期保有目的債券",
            "有価証券評価損",
            "その他有価証券",
            "売買目的有価証券",
            "繰延税金資産"
        ]
    },
    {
        "id": 86,
        "number": 5,
        "subNumber": 1,
        "categoryId": 30,
        "content": "決算日におけるその他有価証券（帳簿価額800円）の時価は820円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "その他有価証券:20",
        "shiwakeRightAnswer": "その他有価証券評価差額金:20",
        "kamokus": [
            "その他有価証券",
            "有価証券評価益",
            "売買目的有価証券",
            "繰延税金負債",
            "満期保有目的債券",
            "その他有価証券評価差額金"
        ]
    },
    {
        "id": 87,
        "number": 1,
        "subNumber": 1,
        "categoryId": 31,
        "content": "決算において、売掛金の期末残高500円に対して貸倒引当金を設定する。なお、Z社に対する売掛金200円については50％の貸倒引当金を設定するが、それ以外の売掛金については貸倒実積率2％で貸倒引当金を設定する。貸倒引当金の期末残高は8円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "貸倒引当金繰入:98",
        "shiwakeRightAnswer": "貸倒引当金:98",
        "kamokus": [
            "貸倒損失",
            "不渡手形",
            "貸倒懸念債権",
            "貸倒引当金繰入",
            "売掛金",
            "貸倒引当金"
        ]
    },
    {
        "id": 88,
        "number": 1,
        "subNumber": 1,
        "categoryId": 32,
        "content": "決算において、修繕引当金100円を設定する。",
        "lecture": "",
        "shiwakeLeftAnswer": "修繕引当金繰入:100",
        "shiwakeRightAnswer": "修繕引当金:100",
        "kamokus": [
            "建物",
            "貸倒引当金",
            "修繕引当金",
            "商品保証引当金",
            "商品保証費",
            "修繕引当金繰入"
        ]
    },
    {
        "id": 89,
        "number": 2,
        "subNumber": 1,
        "categoryId": 32,
        "content": "建物の修繕を行い、修繕費150円を小切手を振り出して支払った。なお、修繕引当金100円がある。",
        "lecture": "",
        "shiwakeLeftAnswer": "修繕引当金:100  修繕費:50",
        "shiwakeRightAnswer": "当座預金:150",
        "kamokus": [
            "当座預金",
            "現金",
            "修繕引当金繰入",
            "修繕費",
            "建物",
            "修繕引当金"
        ]
    },
    {
        "id": 90,
        "number": 1,
        "subNumber": 1,
        "categoryId": 33,
        "content": "決算（3月31日）において、次期の6月10日に支給する賞与600円（計算期間は12月1日から5月31日）について、賞与引当金を設定する。",
        "lecture": "",
        "shiwakeLeftAnswer": "賞与引当金繰入:400",
        "shiwakeRightAnswer": "賞与引当金:400",
        "kamokus": [
            "賞与",
            "賞与引当金繰入",
            "給料",
            "退職給付引当金",
            "現金",
            "賞与引当金"
        ]
    },
    {
        "id": 91,
        "number": 2,
        "subNumber": 1,
        "categoryId": 33,
        "content": "6月10日。賞与600円（計算期間は12月1日から5月31日）を現金で支払った。なお、前期の決算において賞与引当金400円が設定されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "賞与引当金:400  賞与:200",
        "shiwakeRightAnswer": "現金:600",
        "kamokus": [
            "現金",
            "普通預金",
            "賞与引当金繰入",
            "給料",
            "賞与引当金",
            "賞与"
        ]
    },
    {
        "id": 92,
        "number": 1,
        "subNumber": 1,
        "categoryId": 34,
        "content": "決算において、退職給付引当金100円を設定した。",
        "lecture": "",
        "shiwakeLeftAnswer": "退職給付費用:100",
        "shiwakeRightAnswer": "退職給付引当金:100",
        "kamokus": [
            "賞与引当金繰入",
            "現金",
            "賞与引当金",
            "退職給付引当金",
            "給料",
            "退職給付費用"
        ]
    },
    {
        "id": 93,
        "number": 2,
        "subNumber": 1,
        "categoryId": 34,
        "content": "従業員が退職し、退職金500円を当座預金口座から支払った。なお、退職給付引当金の残高は3,000円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "退職給付引当金:500",
        "shiwakeRightAnswer": "当座預金:500",
        "kamokus": [
            "退職給付引当金",
            "退職給付費用",
            "現金",
            "給料",
            "賞与引当金",
            "当座預金"
        ]
    },
    {
        "id": 94,
        "number": 1,
        "subNumber": 1,
        "categoryId": 35,
        "content": "決算において、当期の総売上高20,000円に対して0.2％の商品保証引当金を設定する。",
        "lecture": "",
        "shiwakeLeftAnswer": "商品保証引当金繰入:40",
        "shiwakeRightAnswer": "商品保証引当金:40",
        "kamokus": [
            "商品保証費",
            "売上",
            "商品保証引当金繰入",
            "現金",
            "商品保証引当金戻入",
            "商品保証引当金"
        ]
    },
    {
        "id": 95,
        "number": 2,
        "subNumber": 1,
        "categoryId": 35,
        "content": "前期に販売した商品について、無料修理に応じた。この修理にかかった費用100円を現金で支払った。なお、商品保証引当金の残高は40円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "商品保証引当金:40  商品保証費:60",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "商品保証引当金繰入",
            "現金",
            "商品保証引当金",
            "商品保証引当金戻入",
            "商品保証費",
            "修繕費"
        ]
    },
    {
        "id": 96,
        "number": 3,
        "subNumber": 1,
        "categoryId": 35,
        "content": "決算において、前期の期末に設定した商品保証引当金の残高60円があるが、保証期間が経過したため、これを取り崩す。",
        "lecture": "",
        "shiwakeLeftAnswer": "商品保証引当金:60",
        "shiwakeRightAnswer": "商品保証引当金戻入:60",
        "kamokus": [
            "商品保証費",
            "商品保証引当金戻入",
            "修繕費",
            "現金",
            "売上",
            "商品保証引当金"
        ]
    },
    {
        "id": 97,
        "number": 1,
        "subNumber": 1,
        "categoryId": 36,
        "content": "アメリカのBanana社から商品10ドルを仕入れ、代金は掛けとした。このときの為替相場は1ドル100円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:1000",
        "shiwakeRightAnswer": "買掛金:1000",
        "kamokus": [
            "為替差損益",
            "売掛金",
            "売上",
            "現金",
            "買掛金",
            "仕入"
        ]
    },
    {
        "id": 98,
        "number": 2,
        "subNumber": 1,
        "categoryId": 36,
        "content": "×1年4月20日。アメリカのBanana社から商品10ドルを仕入れる契約をし、手付金2ドルを現金で支払った。このときの為替相場は1ドル101円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "前払金:202",
        "shiwakeRightAnswer": "現金:202",
        "kamokus": [
            "現金",
            "仕入",
            "為替差損益",
            "買掛金",
            "売掛金",
            "前払金"
        ]
    },
    {
        "id": 99,
        "number": 3,
        "subNumber": 1,
        "categoryId": 36,
        "content": "×1年5月1日。アメリカのBanana社から商品10ドルを仕入れ、契約時に支払った手付金2ドル（202円）を控除した残額を翌月末日に支払うことにした。このときの為替相場は1ドル105円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:1042",
        "shiwakeRightAnswer": "前払金:202  買掛金:840",
        "kamokus": [
            "買掛金",
            "為替差損益",
            "前払金",
            "現金",
            "未払金",
            "仕入"
        ]
    },
    {
        "id": 100,
        "number": 4,
        "subNumber": 1,
        "categoryId": 36,
        "content": "アメリカのOrange社に商品20ドルを売り上げ、代金は掛けとした。このときの為替相場は1ドル110円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:2200",
        "shiwakeRightAnswer": "売上:2200",
        "kamokus": [
            "売上",
            "買掛金",
            "為替差損益",
            "売掛金",
            "前受金",
            "未収入金"
        ]
    },
    {
        "id": 101,
        "number": 5,
        "subNumber": 1,
        "categoryId": 36,
        "content": "×1年6月20日。アメリカのOrange社に商品20ドルを売り上げる契約をし、手付金2ドルを現金で受け取った。このときの為替相場は1ドル112円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:224",
        "shiwakeRightAnswer": "前受金:224",
        "kamokus": [
            "為替差損益",
            "前受金",
            "売上",
            "売掛金",
            "買掛金",
            "現金"
        ]
    },
    {
        "id": 102,
        "number": 6,
        "subNumber": 1,
        "categoryId": 36,
        "content": "×1年7月1日。アメリカのOrange社に商品20ドルを売り上げ、契約時に受け取った手付金2ドル（224円）を控除した残額を翌月末日に受け取ることにした。このときの為替相場は1ドル115円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "前受金:224  売掛金:2070",
        "shiwakeRightAnswer": "売上:2294",
        "kamokus": [
            "前払金",
            "売掛金",
            "為替差損益",
            "買掛金",
            "売上",
            "前受金"
        ]
    },
    {
        "id": 103,
        "number": 1,
        "subNumber": 1,
        "categoryId": 37,
        "content": "アメリカのBanana社に対する買掛金8ドルを当座預金口座から決済した。このときの為替相場は1ドル106円である。なお、買掛金8ドルは取引発生時の為替相場（1ドル105円）で計上されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:840  為替差損益:8",
        "shiwakeRightAnswer": "当座預金:848",
        "kamokus": [
            "売掛金",
            "当座預金",
            "前払金",
            "買掛金",
            "仕入",
            "為替差損益"
        ]
    },
    {
        "id": 104,
        "number": 2,
        "subNumber": 1,
        "categoryId": 37,
        "content": "アメリカのOrange社に対する売掛金18ドルが当座預金口座に入金された。このときの為替相場は1ドル116円である。なお、売掛金18ドルは取引発生時の為替相場（1ドル115円）で計上されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:2088",
        "shiwakeRightAnswer": "売掛金:2070  為替差損益:18",
        "kamokus": [
            "前受金",
            "為替差損益",
            "売上",
            "売掛金",
            "当座預金",
            "現金"
        ]
    },
    {
        "id": 105,
        "number": 1,
        "subNumber": 1,
        "categoryId": 38,
        "content": "決算日において、外貨建ての現金（帳簿価額1,000円、10ドル）がある。なお、決算時の為替相場は1ドル111円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:110",
        "shiwakeRightAnswer": "為替差損益:110",
        "kamokus": [
            "現金",
            "当座預金",
            "普通預金",
            "為替差損益",
            "買掛金",
            "売掛金"
        ]
    },
    {
        "id": 106,
        "number": 2,
        "subNumber": 1,
        "categoryId": 38,
        "content": "決算日において、外貨建ての売掛金（帳簿価額2,240円、20ドル）がある。なお、決算時の為替相場は1ドル111円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "為替差損益:20",
        "shiwakeRightAnswer": "売掛金:20",
        "kamokus": [
            "買掛金",
            "為替差損益",
            "現金",
            "売上",
            "売掛金",
            "普通預金"
        ]
    },
    {
        "id": 107,
        "number": 3,
        "subNumber": 1,
        "categoryId": 38,
        "content": "決算日において、外貨建ての買掛金（帳簿価額1,620円、15ドル）がある。なお、決算時の為替相場は1ドル111円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "為替差損益:45",
        "shiwakeRightAnswer": "買掛金:45",
        "kamokus": [
            "仕入",
            "前払金",
            "普通預金",
            "買掛金",
            "現金",
            "為替差損益"
        ]
    },
    {
        "id": 108,
        "number": 1,
        "subNumber": 1,
        "categoryId": 39,
        "content": "2月10日。Banana社から商品10ドルを仕入れ、代金は4月30日に支払うことにした。また取引時に為替予約を付した。この日の直物為替相場は1ドル102円、先物為替相場は1ドル104円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:1040",
        "shiwakeRightAnswer": "買掛金:1040",
        "kamokus": [
            "為替差損益",
            "現金",
            "前払金",
            "売掛金",
            "仕入",
            "買掛金"
        ]
    },
    {
        "id": 109,
        "number": 2,
        "subNumber": 1,
        "categoryId": 39,
        "content": "4月30日。2月10日に発生した買掛金10ドルを当座預金口座から支払った。この日の直物為替相場は1ドル105円である。なお、この買掛金には取引時に1ドル104円で為替予約を付している。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:1040",
        "shiwakeRightAnswer": "当座預金:1040",
        "kamokus": [
            "買掛金",
            "前払金",
            "当座預金",
            "仕入",
            "普通預金",
            "為替差損益"
        ]
    },
    {
        "id": 110,
        "number": 3,
        "subNumber": 1,
        "categoryId": 39,
        "content": "2月10日。Banana社から商品10ドルを仕入れ、代金は4月30日に支払うことにした。この日の直物為替相場は1ドル102円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:1020",
        "shiwakeRightAnswer": "買掛金:1020",
        "kamokus": [
            "仕入",
            "為替差損益",
            "未払金",
            "前払金",
            "買掛金",
            "普通預金"
        ]
    },
    {
        "id": 111,
        "number": 4,
        "subNumber": 1,
        "categoryId": 39,
        "content": "2月28日。2月10日にBanana社から商品10ドルを仕入れたさいに生じた買掛金10ドル（帳簿価額1,020円）について為替予約を付した。なお、この日の直物為替相場は1ドル103円、先物為替相場は1ドル105円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "為替差損益:30",
        "shiwakeRightAnswer": "買掛金:30",
        "kamokus": [
            "前払金",
            "買掛金",
            "仕入",
            "当座預金",
            "現金",
            "為替差損益"
        ]
    },
    {
        "id": 112,
        "number": 5,
        "subNumber": 1,
        "categoryId": 39,
        "content": "4月30日。2月10日に発生した買掛金10ドルを当座預金口座から支払った。この日の直物為替相場は1ドル104円である。なお、この買掛金には2月28日に1ドル105円で為替予約を付している。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:1050",
        "shiwakeRightAnswer": "当座預金:1050",
        "kamokus": [
            "買掛金",
            "普通預金",
            "為替差損益",
            "現金",
            "仕入",
            "当座預金"
        ]
    },
    {
        "id": 113,
        "number": 1,
        "subNumber": 1,
        "categoryId": 40,
        "content": "会社設立にあたり、株式50株を１株100円で発行し、払込金額は普通預金とした。なお、株式発行費用10円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "普通預金:5000  創立費:10",
        "shiwakeRightAnswer": "資本金:5000  現金:10",
        "kamokus": [
            "資本金",
            "創立費",
            "株式交付費",
            "繰越利益剰余金",
            "現金",
            "普通預金"
        ]
    },
    {
        "id": 114,
        "number": 2,
        "subNumber": 1,
        "categoryId": 40,
        "content": "会社設立にあたり、株式50株を１株100円で発行し、払込金額は普通預金とした。払込金額のうち会社法で認められる最低額を資本金とした。なお、株式発行費用10円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "普通預金:5000  創立費:10",
        "shiwakeRightAnswer": "資本金:2500  資本準備金:2500  現金:10",
        "kamokus": [
            "普通預金",
            "資本金",
            "現金",
            "株式交付費",
            "創立費",
            "資本準備金"
        ]
    },
    {
        "id": 115,
        "number": 3,
        "subNumber": 1,
        "categoryId": 40,
        "content": "増資にあたり、株式40株を１株150円で発行し、払込金額は当座預金とした。なお、株式発行費用15円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:6000  株式交付費:15",
        "shiwakeRightAnswer": "資本金:6000  現金:15",
        "kamokus": [
            "創立費",
            "現金",
            "株式交付費",
            "株式申込証拠金",
            "資本金",
            "当座預金"
        ]
    },
    {
        "id": 116,
        "number": 4,
        "subNumber": 1,
        "categoryId": 40,
        "content": "増資にあたり、株式40株を１株150円で発行し、払込金額は当座預金とした。払込金額のうち会社法で認められる最低額を資本金とした。なお、株式発行費用15円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:6000  株式交付費:15",
        "shiwakeRightAnswer": "資本金:3000  資本準備金:3000  現金:15",
        "kamokus": [
            "資本準備金",
            "株式申込証拠金",
            "現金",
            "資本金",
            "当座預金",
            "株式交付費"
        ]
    },
    {
        "id": 117,
        "number": 5,
        "subNumber": 1,
        "categoryId": 40,
        "content": "増資にあたり、株式40株を１株150円で発行することになり、株主を募集したところ、全額について申し込みがあったので、申込証拠金を別段預金に預け入れた。",
        "lecture": "",
        "shiwakeLeftAnswer": "別段預金:6000",
        "shiwakeRightAnswer": "株式申込証拠金:6000",
        "kamokus": [
            "株式交付費",
            "別段預金",
            "当座預金",
            "資本準備金",
            "資本金",
            "株式申込証拠金"
        ]
    },
    {
        "id": 118,
        "number": 6,
        "subNumber": 1,
        "categoryId": 40,
        "content": "増資にあたり、株式40株を１株150円で発行することになり、株主を募集したところ、全額について申し込みがあったので、申込証拠金を別段預金に預け入れた（適正に処理済）。本日、払込期日になり、申込者全員に株式を割り当てた。別段預金は当座預金に振り替え、資本金の額は会社法の定める最低額とした。",
        "lecture": "",
        "shiwakeLeftAnswer": "株式申込証拠金:6000  当座預金:6000",
        "shiwakeRightAnswer": "資本金:3000  資本準備金:3000  別段預金:6000",
        "kamokus": [
            "当座預金",
            "株式交付費",
            "別段預金",
            "資本金",
            "株式申込証拠金",
            "資本準備金"
        ]
    },
    {
        "id": 119,
        "number": 1,
        "subNumber": 1,
        "categoryId": 41,
        "content": "TO社はG社を吸収合併し、G社の株主に対し、株式10株を交付した。TO社株式の時価は＠60円である。なお、G社の諸資産（時価）は900円、諸負債（時価）は400円である。発行した株式については全額を資本金として処理する。",
        "lecture": "",
        "shiwakeLeftAnswer": "諸資産:900  のれん:100",
        "shiwakeRightAnswer": "諸負債:400  資本金:600",
        "kamokus": [
            "株式交付費",
            "資本金",
            "諸負債",
            "のれん",
            "資本準備金",
            "諸資産"
        ]
    },
    {
        "id": 120,
        "number": 2,
        "subNumber": 1,
        "categoryId": 41,
        "content": "決算において、当期首に発生したのれん100円を10年間で均等償却する。",
        "lecture": "",
        "shiwakeLeftAnswer": "のれん償却:10",
        "shiwakeRightAnswer": "のれん:10",
        "kamokus": [
            "減価償却費",
            "償却債権取立益",
            "資本金",
            "現金",
            "のれん",
            "のれん償却"
        ]
    },
    {
        "id": 121,
        "number": 1,
        "subNumber": 1,
        "categoryId": 42,
        "content": "決算において、当期純利益200円を計上した。",
        "lecture": "",
        "shiwakeLeftAnswer": "損益:200",
        "shiwakeRightAnswer": "繰越利益剰余金:200",
        "kamokus": [
            "当期純利益",
            "資本金",
            "現金",
            "繰越利益剰余金",
            "未払配当金",
            "損益"
        ]
    },
    {
        "id": 122,
        "number": 2,
        "subNumber": 1,
        "categoryId": 42,
        "content": "決算において、当期純損失100円を計上した。",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:100",
        "shiwakeRightAnswer": "損益:100",
        "kamokus": [
            "損益",
            "当期純損失",
            "繰越利益剰余金",
            "利益準備金",
            "雑損",
            "資本金"
        ]
    },
    {
        "id": 123,
        "number": 1,
        "subNumber": 1,
        "categoryId": 43,
        "content": "株主総会において、繰越利益剰余金を次のように配当等することが承認された。<br> 株主配当金 300円 利益準備金 30円 別途積立金 20円",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:350",
        "shiwakeRightAnswer": "未払配当金:300  利益準備金:30  別途積立金:20",
        "kamokus": [
            "別途積立金",
            "利益準備金",
            "資本準備金",
            "未払配当金",
            "資本金",
            "繰越利益剰余金"
        ]
    },
    {
        "id": 124,
        "number": 2,
        "subNumber": 1,
        "categoryId": 43,
        "content": "株主総会において、その他資本剰余金を次のように配当等することが承認された。<br> 株主配当金 200円 資本準備金 20円",
        "lecture": "",
        "shiwakeLeftAnswer": "その他資本剰余金:220",
        "shiwakeRightAnswer": "未払配当金:200  資本準備金:20",
        "kamokus": [
            "未払配当金",
            "資本準備金",
            "資本金",
            "受取配当金",
            "繰越利益剰余金",
            "その他資本剰余金"
        ]
    },
    {
        "id": 125,
        "number": 3,
        "subNumber": 1,
        "categoryId": 43,
        "content": "株主総会において承認された株主配当金200円を、当座預金口座から支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払配当金:200",
        "shiwakeRightAnswer": "当座預金:200",
        "kamokus": [
            "受取配当金",
            "繰越利益剰余金",
            "その他資本剰余金",
            "現金",
            "当座預金",
            "未払配当金"
        ]
    },
    {
        "id": 126,
        "number": 1,
        "subNumber": 1,
        "categoryId": 44,
        "content": "株主総会において、繰越利益剰余金を次のように配当等することが承認された。なお、資本金は1,000円、資本準備金は100円、利益準備金は60円であった。<br> 株主配当金 200円 利益準備金 ？円（各自推定）",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:220",
        "shiwakeRightAnswer": "未払配当金:200  利益準備金:20",
        "kamokus": [
            "未払配当金",
            "利益準備金",
            "資本準備金",
            "資本金",
            "受取配当金",
            "繰越利益剰余金"
        ]
    },
    {
        "id": 127,
        "number": 2,
        "subNumber": 1,
        "categoryId": 44,
        "content": "株主総会において、その他資本剰余金を次のように配当等することが承認された。なお、資本金は800円、資本準備金は150円、利益準備金は40円であった。<br> 株主配当金200円 資本準備金？円（各自推定）",
        "lecture": "",
        "shiwakeLeftAnswer": "その他資本剰余金:210",
        "shiwakeRightAnswer": "未払配当金:200  資本準備金:10",
        "kamokus": [
            "その他資本剰余金",
            "資本金",
            "未払配当金",
            "資本準備金",
            "利益準備金",
            "受取配当金"
        ]
    },
    {
        "id": 128,
        "number": 3,
        "subNumber": 1,
        "categoryId": 44,
        "content": "株主総会において、繰越利益剰余金とその他資本剰余金を財源とした剰余金の配当等が次のように承認された。なお、資本金は1,000円、資本準備金は100円、利益準備金は60円であった。<br> 繰越利益剰余金からの株主配当金 300円、 その他資本剰余金からの株主配当金 200円<br> 利益準備金 ？円（各自計算）、資本準備金 ？円（各自計算）",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:330  その他資本剰余金:220",
        "shiwakeRightAnswer": "未払配当金:500  利益準備金:30  資本準備金:20",
        "kamokus": [
            "資本準備金",
            "利益準備金",
            "資本金",
            "未払配当金",
            "その他資本剰余金",
            "繰越利益剰余金"
        ]
    },
    {
        "id": 129,
        "number": 1,
        "subNumber": 1,
        "categoryId": 45,
        "content": "当期に株式を発行し、1,000円の払い込みを受け、当座預金とした。なお、払込金額のうち600円は資本金とし、残額は資本準備金とした。",
        "lecture": "",
        "shiwakeLeftAnswer": "当座預金:1000",
        "shiwakeRightAnswer": "資本金:600  資本準備金:400",
        "kamokus": [
            "当座預金",
            "資本準備金",
            "株式交付費",
            "利益準備金",
            "別段預金",
            "資本金"
        ]
    },
    {
        "id": 130,
        "number": 2,
        "subNumber": 1,
        "categoryId": 45,
        "content": "株主総会において、繰越利益剰余金を次のように配当等することが承認された。<br> 株主配当金 200円 利益準備金 20円",
        "lecture": "",
        "shiwakeLeftAnswer": "繰越利益剰余金:220",
        "shiwakeRightAnswer": "未払配当金:200  利益準備金:20",
        "kamokus": [
            "未払配当金",
            "当座預金",
            "繰越利益剰余金",
            "受取配当金",
            "資本準備金",
            "利益準備金"
        ]
    },
    {
        "id": 131,
        "number": 3,
        "subNumber": 1,
        "categoryId": 45,
        "content": "決算において、当期純利益100円を計上した。",
        "lecture": "",
        "shiwakeLeftAnswer": "損益:100",
        "shiwakeRightAnswer": "繰越利益剰余金:100",
        "kamokus": [
            "雑益",
            "資本金",
            "当期純利益",
            "損益",
            "利益準備金",
            "繰越利益剰余金"
        ]
    },
    {
        "id": 132,
        "number": 4,
        "subNumber": 1,
        "categoryId": 45,
        "content": "決算において、その他有価証券（帳簿価額80円）を時価95円に評価替えした。",
        "lecture": "",
        "shiwakeLeftAnswer": "その他有価証券:15",
        "shiwakeRightAnswer": "その他有価証券評価差額金:15",
        "kamokus": [
            "売買目的有価証券",
            "有価証券評価益",
            "繰延税金負債",
            "その他有価証券",
            "繰延税金資産",
            "その他有価証券評価差額金"
        ]
    },
    {
        "id": 133,
        "number": 5,
        "subNumber": 1,
        "categoryId": 45,
        "content": "利益準備金800円を繰越利益剰余金に振り替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "利益準備金:800",
        "shiwakeRightAnswer": "繰越利益剰余金:800",
        "kamokus": [
            "資本準備金",
            "その他資本剰余金",
            "繰越利益剰余金",
            "資本金",
            "未払配当金",
            "利益準備金"
        ]
    },
    {
        "id": 134,
        "number": 6,
        "subNumber": 1,
        "categoryId": 45,
        "content": "資本準備金900円をその他資本剰余金に振り替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "資本準備金:900",
        "shiwakeRightAnswer": "その他資本剰余金:900",
        "kamokus": [
            "資本金",
            "利益準備金",
            "別途積立金",
            "繰越利益剰余金",
            "その他資本剰余金",
            "資本準備金"
        ]
    },
    {
        "id": 135,
        "number": 1,
        "subNumber": 1,
        "categoryId": 46,
        "content": "商品100円（税抜価格）を仕入れ、代金は掛けとした。消費税率は10％である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100  仮払消費税:10",
        "shiwakeRightAnswer": "買掛金:110",
        "kamokus": [
            "買掛金",
            "仕入",
            "仮受消費税",
            "仮払金",
            "売掛金",
            "仮払消費税"
        ]
    },
    {
        "id": 136,
        "number": 2,
        "subNumber": 1,
        "categoryId": 46,
        "content": "商品300円（税抜価格）を売り上げ、代金は掛けとした。消費税率は10％である。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:330",
        "shiwakeRightAnswer": "売上:300  仮受消費税:30",
        "kamokus": [
            "仮受消費税",
            "仮受金",
            "仮払消費税",
            "売掛金",
            "買掛金",
            "売上"
        ]
    },
    {
        "id": 137,
        "number": 3,
        "subNumber": 1,
        "categoryId": 46,
        "content": "決算において、消費税の納付額を計算する。なお、仮払消費税は10円、仮受消費税は30円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仮受消費税:30",
        "shiwakeRightAnswer": "仮払消費税:10  未払消費税:20",
        "kamokus": [
            "仮受金",
            "仮払消費税",
            "仮払法人税等",
            "仮受消費税",
            "法人税、住民税及び事業税",
            "未払消費税"
        ]
    },
    {
        "id": 138,
        "number": 4,
        "subNumber": 1,
        "categoryId": 46,
        "content": "未払消費税20円を当座預金口座から支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払消費税:20",
        "shiwakeRightAnswer": "当座預金:20",
        "kamokus": [
            "未払金",
            "当座預金",
            "未払配当金",
            "未払利息",
            "未払消費税",
            "普通預金"
        ]
    },
    {
        "id": 139,
        "number": 1,
        "subNumber": 1,
        "categoryId": 47,
        "content": "法人税等の中間申告で300円を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仮払法人税等:300",
        "shiwakeRightAnswer": "現金:300",
        "kamokus": [
            "現金",
            "仮払金",
            "仮払消費税",
            "当座預金",
            "未払法人税等",
            "仮払法人税等"
        ]
    },
    {
        "id": 140,
        "number": 2,
        "subNumber": 1,
        "categoryId": 47,
        "content": "決算において、当期の法人税等が800円と確定した。なお、中間申告額300円は仮払法人税等に計上されている。",
        "lecture": "",
        "shiwakeLeftAnswer": "法人税、住民税及び事業税:800",
        "shiwakeRightAnswer": "仮払法人税等:300  未払法人税等:500",
        "kamokus": [
            "未払法人税等",
            "仮払消費税",
            "未払消費税",
            "仮払法人税等",
            "当座預金",
            "法人税、住民税及び事業税"
        ]
    },
    {
        "id": 141,
        "number": 3,
        "subNumber": 1,
        "categoryId": 47,
        "content": "未払法人税等500円を現金で納付した。",
        "lecture": "",
        "shiwakeLeftAnswer": "未払法人税等:500",
        "shiwakeRightAnswer": "現金:500",
        "kamokus": [
            "当座預金",
            "未払消費税",
            "未払金",
            "現金",
            "法人税、住民税及び事業税",
            "未払法人税等"
        ]
    },
    {
        "id": 142,
        "number": 1,
        "subNumber": 1,
        "categoryId": 48,
        "content": "当期の決算において、税引前当期純利益が900円と計算されたが、当期に費用計上した減価償却費400円のうち100円が損金不算入となった。課税所得に対して40％の法人税を計上する。なお、仮払法人税等はない。",
        "lecture": "",
        "shiwakeLeftAnswer": "法人税、住民税及び事業税:400",
        "shiwakeRightAnswer": "未払法人税等:400",
        "kamokus": [
            "未払法人税等",
            "減価償却費",
            "法人税、住民税及び事業税",
            "未払消費税",
            "仮払法人税等",
            "当座預金"
        ]
    },
    {
        "id": 143,
        "number": 2,
        "subNumber": 1,
        "categoryId": 48,
        "content": "当期の決算において、税引前当期純利益が450円と計算されたが、貸倒引当金の当期繰入額50円が損金不算入となった。課税所得に対して40％の法人税を計上する。なお、仮払法人税等はない。",
        "lecture": "",
        "shiwakeLeftAnswer": "法人税、住民税及び事業税:200",
        "shiwakeRightAnswer": "未払法人税等:200",
        "kamokus": [
            "未払配当金",
            "損益",
            "貸倒引当金繰入",
            "未払法人税等",
            "貸倒引当金",
            "法人税、住民税及び事業税"
        ]
    },
    {
        "id": 144,
        "number": 1,
        "subNumber": 1,
        "categoryId": 49,
        "content": "第1期の決算において、売掛金に対して100円の貸倒引当金を繰り入れたが全額が損金不算入となった。なお、法人税等の実効税率は40％とする。",
        "lecture": "",
        "shiwakeLeftAnswer": "繰延税金資産:40",
        "shiwakeRightAnswer": "法人税等調整額:40",
        "kamokus": [
            "貸倒引当金",
            "法人税、住民税及び事業税",
            "法人税等調整額",
            "損益",
            "貸倒引当金繰入",
            "繰延税金資産"
        ]
    },
    {
        "id": 145,
        "number": 2,
        "subNumber": 1,
        "categoryId": 49,
        "content": "第1期末で計上した貸倒引当金100円にかかる売掛金が貸し倒れ、損金算入が認められた。また、第2期末において、売掛金に対して150円の貸倒引当金を繰り入れたが全額が損金不算入となった。なお、法人税等の実効税率は40％とする。",
        "lecture": "",
        "shiwakeLeftAnswer": "繰延税金資産:20",
        "shiwakeRightAnswer": "法人税等調整額:20",
        "kamokus": [
            "貸倒引当金繰入",
            "貸倒引当金",
            "繰越利益剰余金",
            "繰延税金負債",
            "繰延税金資産",
            "法人税等調整額"
        ]
    },
    {
        "id": 146,
        "number": 3,
        "subNumber": 1,
        "categoryId": 49,
        "content": "第1期の決算において、備品の減価償却費500円を計上したが、このうち200円が損金不算入となった。なお、法人税等の実効税率は40％とする。",
        "lecture": "",
        "shiwakeLeftAnswer": "繰延税金資産:80",
        "shiwakeRightAnswer": "法人税等調整額:80",
        "kamokus": [
            "法人税、住民税及び事業税",
            "仮払法人税等",
            "未払法人税等",
            "繰延税金資産",
            "法人税等調整額",
            "繰延税金負債"
        ]
    },
    {
        "id": 147,
        "number": 4,
        "subNumber": 1,
        "categoryId": 49,
        "content": "第1期末におけるその他有価証券（帳簿価額120円）の時価は160円であった。法人税等の実効税率は40％として税効果会計を適用する。",
        "lecture": "",
        "shiwakeLeftAnswer": "その他有価証券:40",
        "shiwakeRightAnswer": "その他有価証券評価差額金:24  繰延税金負債:16",
        "kamokus": [
            "繰延税金資産",
            "法人税等調整額",
            "有価証券評価益",
            "その他有価証券評価差額金",
            "繰延税金負債",
            "その他有価証券"
        ]
    },
    {
        "id": 148,
        "number": 5,
        "subNumber": 1,
        "categoryId": 49,
        "content": "第1期末におけるその他有価証券（帳簿価額120円）の時価は160円であった。法人税等の実効税率は40％として税効果会計を適用する（適正に処理済）。本日の第2期の期首において、評価差額について再振替仕訳をした。",
        "lecture": "",
        "shiwakeLeftAnswer": "その他有価証券評価差額金:24  繰延税金負債:16",
        "shiwakeRightAnswer": "その他有価証券:40",
        "kamokus": [
            "法人税等調整額",
            "繰延税金資産",
            "繰延税金負債",
            "その他有価証券",
            "その他有価証券評価差額金",
            "法人税等調整額"
        ]
    },
    {
        "id": 149,
        "number": 1,
        "subNumber": 1,
        "categoryId": 50,
        "content": "×1年4月1日（期首）に、TO社はX社と商品の販売と2年間の保守サービスを提供する1つの契約を締結し、契約と同時に商品の引渡しを行い、対価120円を現金で受け取った。なお、保守サービスの期間は×1年4月1日から×3年3月31日までであり、契約書に記載された対価の額は120円である（商品の販売価格は100円、保守サービスの販売価格は20円とする）。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:120",
        "shiwakeRightAnswer": "売上:100  契約負債:20",
        "kamokus": [
            "売上",
            "契約負債",
            "仕入",
            "返金負債",
            "契約資産",
            "現金"
        ]
    },
    {
        "id": 150,
        "number": 2,
        "subNumber": 1,
        "categoryId": 50,
        "content": "×1年4月1日（期首）に、TO社はX社と商品の販売と2年間の保守サービスを提供する1つの契約を締結し、契約と同時に商品の引渡しを行い、対価120円を現金で受け取った。なお、保守サービスの期間は×1年4月1日から×3年3月31日までであり、契約書に記載された対価の額は120円である（商品の販売価格は100円、保守サービスの販売価格は20円とする）。<br> 本日、決算日（×2年3月31日）につき履行義務を充足した部分につき収益を認識する。",
        "lecture": "",
        "shiwakeLeftAnswer": "契約負債:10",
        "shiwakeRightAnswer": "売上:10",
        "kamokus": [
            "契約資産",
            "返金負債",
            "現金",
            "保証債務",
            "売上",
            "契約負債"
        ]
    },
    {
        "id": 151,
        "number": 1,
        "subNumber": 1,
        "categoryId": 51,
        "content": "×1年4月1日に、TO社はX社と商品甲と商品乙を販売する契約を結んだ。商品甲は契約と同時（×1年4月1日）に引渡しを行い、商品乙の引渡しは月末（×1年4月30日）に行う。なお、 商品甲の対価は200円、商品乙の対価は400円であるが、商品甲の対価の支払いは商品乙の引渡しが完了するまで留保される。",
        "lecture": "",
        "shiwakeLeftAnswer": "契約資産:200",
        "shiwakeRightAnswer": "売上:200",
        "kamokus": [
            "売掛金",
            "前受金",
            "現金",
            "契約資産",
            "契約負債",
            "売上"
        ]
    },
    {
        "id": 152,
        "number": 2,
        "subNumber": 1,
        "categoryId": 51,
        "content": "×1年4月1日に、TO社はX社と商品甲と商品乙を販売する契約を結んだ。商品甲は契約と同時（×1年4月1日）に引渡しを行い、商品乙の引渡しは月末（×1年4月30日）に行う。なお、 商品甲の対価は200円、商品乙の対価は400円であるが、商品甲の対価の支払いは商品乙の引渡しが完了するまで留保される（適正に処理済）。本日、4月30日となり当初の予定通り商品乙をX社へ引き渡した。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:600",
        "shiwakeRightAnswer": "売上:400  契約資産:200",
        "kamokus": [
            "契約負債",
            "当座預金",
            "契約資産",
            "前受金",
            "売上",
            "売掛金"
        ]
    },
    {
        "id": 153,
        "number": 1,
        "subNumber": 1,
        "categoryId": 52,
        "content": "×1年10月1日にTO社は商品甲（＠10円）を20個販売し、現金を受け取った。なお、販売個数が当期中に50個に達したときには、1個あたり1円のリベートを現金で支払うという条件があり、当期における商品甲のＸ社への販売個数は60個と予想している。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:200",
        "shiwakeRightAnswer": "売上:180  返金負債:20",
        "kamokus": [
            "仕入",
            "返金負債",
            "契約負債",
            "売上",
            "売掛金",
            "現金"
        ]
    },
    {
        "id": 154,
        "number": 2,
        "subNumber": 1,
        "categoryId": 52,
        "content": "×1年10月1日にTO社は商品甲（＠10円）を20個販売した。なお、販売個数が当期中に50個に達したときには1個あたり1円のリベートを現金で支払うという条件があり、当期における商品甲のＸ社への販売個数は60個と予想している（適正に処理済）。その後、×1年12月1日にTO社はX社に商品甲を35個販売し、現金を受け取った。また、商品甲のＸ社への当期販売個数が55個となった（50個に達した）ため、売上割戻しを適用し、リベートを現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:350  返金負債:55",
        "shiwakeRightAnswer": "売上:315  返金負債:35  現金:55",
        "kamokus": [
            "前受金",
            "契約負債",
            "売掛金",
            "返金負債",
            "現金",
            "売上"
        ]
    },
    {
        "id": 155,
        "number": 3,
        "subNumber": 1,
        "categoryId": 52,
        "content": "×1年10月1日にTO社は商品甲（＠10円）を20個販売した。なお、販売個数が当期中に50個に達したときには1個あたり1円のリベートを現金で支払うという条件があり、当期における商品甲のＸ社への販売個数は60個と予想している（適正に処理済）。その後、×2年3月31日（決算日）において、当期のX社に対する商品甲の販売個数が50個に達しなかったため、計上している返金負債20円を売上に振り替えた。",
        "lecture": "",
        "shiwakeLeftAnswer": "返金負債:20",
        "shiwakeRightAnswer": "売上:20",
        "kamokus": [
            "契約負債",
            "売掛金",
            "売上",
            "現金",
            "仕入",
            "返金負債"
        ]
    },
    {
        "id": 156,
        "number": 1,
        "subNumber": 1,
        "categoryId": 53,
        "content": "支店を開設し、本店は支店に下記の資産を移送した。本店の仕訳を示しなさい。<br> 現金 100円 備品 300円",
        "lecture": "",
        "shiwakeLeftAnswer": "支店:400",
        "shiwakeRightAnswer": "現金:100  備品:300",
        "kamokus": [
            "備品",
            "本店",
            "仕入",
            "建物",
            "現金",
            "支店"
        ]
    },
    {
        "id": 157,
        "number": 2,
        "subNumber": 1,
        "categoryId": 53,
        "content": "支店を開設し、本店は支店に下記の資産を移送した。支店の仕訳を示しなさい。<br> 現金 100円 備品 300円",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100  備品:300",
        "shiwakeRightAnswer": "本店:400",
        "kamokus": [
            "支店",
            "買掛金",
            "本店",
            "仕入",
            "備品",
            "現金"
        ]
    },
    {
        "id": 158,
        "number": 3,
        "subNumber": 1,
        "categoryId": 53,
        "content": "本店は、支店の買掛金100円を現金で支払った。本店の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "支店:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "本店",
            "現金",
            "売掛金",
            "仕入",
            "買掛金",
            "支店"
        ]
    },
    {
        "id": 159,
        "number": 4,
        "subNumber": 1,
        "categoryId": 53,
        "content": "本店は、支店の買掛金100円を現金で支払った。支店の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100",
        "shiwakeRightAnswer": "本店:100",
        "kamokus": [
            "現金",
            "支店",
            "仕入",
            "本店",
            "売掛金",
            "買掛金"
        ]
    },
    {
        "id": 160,
        "number": 5,
        "subNumber": 1,
        "categoryId": 53,
        "content": "本店は、支店が支払うべき手数料100円を現金で立替払いした。本店の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "支店:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "立替金",
            "本店",
            "未払金",
            "現金",
            "支払手数料",
            "支店"
        ]
    },
    {
        "id": 161,
        "number": 6,
        "subNumber": 1,
        "categoryId": 53,
        "content": "本店は、支店が支払うべき手数料100円を現金で立替払いした。支店の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払手数料:100",
        "shiwakeRightAnswer": "本店:100",
        "kamokus": [
            "本店",
            "現金",
            "立替金",
            "支店",
            "受取手数料",
            "支払手数料"
        ]
    },
    {
        "id": 162,
        "number": 7,
        "subNumber": 1,
        "categoryId": 53,
        "content": "本店は、 原価100円の商品を支店に送付した。本店の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "支店:100",
        "shiwakeRightAnswer": "仕入:100",
        "kamokus": [
            "売上",
            "本店",
            "現金",
            "売掛金",
            "支店",
            "仕入"
        ]
    },
    {
        "id": 163,
        "number": 8,
        "subNumber": 1,
        "categoryId": 53,
        "content": "本店は、 原価100円の商品を支店に送付した。支店の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕入:100",
        "shiwakeRightAnswer": "本店:100",
        "kamokus": [
            "買掛金",
            "現金",
            "仕入",
            "支店",
            "売上",
            "本店"
        ]
    },
    {
        "id": 164,
        "number": 9,
        "subNumber": 1,
        "categoryId": 53,
        "content": "埼玉支店は山梨支店に現金100円を送金した。埼玉支店の仕訳を示しなさい。なお、当社では支店分散計算制度を採用している。",
        "lecture": "",
        "shiwakeLeftAnswer": "山梨支店:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "本店",
            "当座預金",
            "支店",
            "埼玉支店",
            "現金",
            "山梨支店"
        ]
    },
    {
        "id": 165,
        "number": 10,
        "subNumber": 1,
        "categoryId": 53,
        "content": "埼玉支店は山梨支店に現金100円を送金した。山梨支店の仕訳を示しなさい。なお、当社では支店分散計算制度を採用している。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "埼玉支店:100",
        "kamokus": [
            "現金",
            "本店",
            "埼玉支店",
            "普通預金",
            "山梨支店",
            "支店"
        ]
    },
    {
        "id": 166,
        "number": 11,
        "subNumber": 1,
        "categoryId": 53,
        "content": "埼玉支店は山梨支店に現金100円を送金した。本店の仕訳を示しなさい。なお、当社では本店集中計算制度を採用している。",
        "lecture": "",
        "shiwakeLeftAnswer": "山梨支店:100",
        "shiwakeRightAnswer": "埼玉支店:100",
        "kamokus": [
            "本店",
            "山梨支店",
            "現金",
            "支店",
            "普通預金",
            "埼玉支店"
        ]
    },
    {
        "id": 167,
        "number": 12,
        "subNumber": 1,
        "categoryId": 53,
        "content": "埼玉支店は山梨支店に現金100円を送金した。埼玉支店の仕訳を示しなさい。なお、当社では本店集中計算制度を採用している。",
        "lecture": "",
        "shiwakeLeftAnswer": "本店:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "埼玉支店",
            "当座預金",
            "山梨支店",
            "送金小切手",
            "本店",
            "現金"
        ]
    },
    {
        "id": 168,
        "number": 13,
        "subNumber": 1,
        "categoryId": 53,
        "content": "埼玉支店は山梨支店に現金100円を送金した。山梨支店の仕訳を示しなさい。なお、当社では本店集中計算制度を採用している。",
        "lecture": "",
        "shiwakeLeftAnswer": "現金:100",
        "shiwakeRightAnswer": "本店:100",
        "kamokus": [
            "現金",
            "山梨支店",
            "本店",
            "当座預金",
            "支店",
            "埼玉支店"
        ]
    },
    {
        "id": 169,
        "number": 14,
        "subNumber": 1,
        "categoryId": 53,
        "content": "決算において、備品について下記のとおり減価償却費を計上する（記帳方法は間接法）。本店の仕訳を示しなさい。<br> 本店：200円 支店：100円",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:200",
        "shiwakeRightAnswer": "備品減価償却累計額:200",
        "kamokus": [
            "本店",
            "備品",
            "備品減価償却累計額",
            "建物減価償却累計額",
            "減価償却費",
            "支店"
        ]
    },
    {
        "id": 170,
        "number": 15,
        "subNumber": 1,
        "categoryId": 53,
        "content": "決算において、備品について下記のとおり減価償却費を計上する（記帳方法は間接法）。支店の仕訳を示しなさい。<br> 本店：200円 支店：100円",
        "lecture": "",
        "shiwakeLeftAnswer": "減価償却費:100",
        "shiwakeRightAnswer": "備品減価償却累計額:100",
        "kamokus": [
            "建物減価償却累計額",
            "支店",
            "本店",
            "備品減価償却累計額",
            "備品",
            "減価償却費"
        ]
    },
    {
        "id": 171,
        "number": 1,
        "subNumber": 1,
        "categoryId": 54,
        "content": "×1年3月31日。TO社はS社の発行済株式（S社株式）の100％を500円で取得して、S社を子会社とした。なお、S社の貸借対照表は下記のとおりである。<br> 資本金：300円<br> 利益剰余金：200円",
        "lecture": "",
        "shiwakeLeftAnswer": "資本金:300  利益剰余金:200",
        "shiwakeRightAnswer": "S社株式:500",
        "kamokus": [
            "資本剰余金",
            "のれん",
            "非支配株主持分",
            "S社株式",
            "利益剰余金",
            "資本金"
        ]
    },
    {
        "id": 172,
        "number": 2,
        "subNumber": 1,
        "categoryId": 54,
        "content": "×1年3月31日。TO社はS社の発行済株式（S社株式）の60％を300円で取得して、S社を子会社とした。なお、S社の貸借対照表は下記のとおりである。<br> 資本金：300円<br> 利益剰余金：200円",
        "lecture": "",
        "shiwakeLeftAnswer": "資本金:300  利益剰余金:200",
        "shiwakeRightAnswer": "S社株式:300  非支配株主持分:200",
        "kamokus": [
            "利益剰余金",
            "その他資本剰余金",
            "資本金",
            "のれん",
            "非支配株主持分",
            "S社株式"
        ]
    },
    {
        "id": 173,
        "number": 3,
        "subNumber": 1,
        "categoryId": 54,
        "content": "×1年3月31日。TO社はS社の発行済株式（S社株式）の60％を400円で取得して、S社を子会社とした。なお、S社の貸借対照表は下記のとおりである。<br> 資本金：300円<br> 利益剰余金：200円",
        "lecture": "",
        "shiwakeLeftAnswer": "資本金:300  利益剰余金:200  のれん:100",
        "shiwakeRightAnswer": "S社株式:400  非支配株主持分:200",
        "kamokus": [
            "資本金",
            "非支配株主持分",
            "S社株式",
            "資本剰余金",
            "のれん",
            "利益剰余金"
        ]
    },
    {
        "id": 174,
        "number": 1,
        "subNumber": 1,
        "categoryId": 55,
        "content": "TO社はS社の発行済株式の60％を所有している。S社の支配獲得日（×1年3月31日）において発生したのれん100円を償却期間10年で償却する。",
        "lecture": "",
        "shiwakeLeftAnswer": "のれん償却:10",
        "shiwakeRightAnswer": "のれん:10",
        "kamokus": [
            "減価償却費",
            "特許権償却",
            "のれん",
            "償却債権取立益",
            "のれん償却",
            "ソフトウェア償却"
        ]
    },
    {
        "id": 175,
        "number": 2,
        "subNumber": 1,
        "categoryId": 55,
        "content": "TO社はS社の発行済株式の60％を所有している。S社の当期純利益は200円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "非支配株主に帰属する当期純利益:80",
        "shiwakeRightAnswer": "非支配株主持分:80",
        "kamokus": [
            "当期純利益",
            "資本金",
            "非支配株主持分",
            "利益剰余金",
            "S社株式",
            "非支配株主に帰属する当期純利益"
        ]
    },
    {
        "id": 176,
        "number": 3,
        "subNumber": 1,
        "categoryId": 55,
        "content": "TO社はS社の発行済株式の60％を所有している。S社は当期に50円の配当を行っている。",
        "lecture": "",
        "shiwakeLeftAnswer": "受取配当金:30  非支配株主持分:20",
        "shiwakeRightAnswer": "利益剰余金:50",
        "kamokus": [
            "未払配当金",
            "非支配株主持分",
            "S社株式",
            "受取配当金",
            "資本金",
            "利益剰余金"
        ]
    },
    {
        "id": 177,
        "number": 1,
        "subNumber": 1,
        "categoryId": 56,
        "content": "TO社はS社の発行済株式の60％を所有している。連結会社間（TO社とS社）の取引高と債権債務残高は次のとおりである。<br> 【TO社からS社】<br> 売上高500円、売掛金100円<br> 【S社からTO社】<br> 売上原価（仕入）500円、買掛金100円",
        "lecture": "",
        "shiwakeLeftAnswer": "売上高:500  買掛金:100",
        "shiwakeRightAnswer": "売上原価:500  売掛金:100",
        "kamokus": [
            "売掛金",
            "非支配株主持分",
            "売上高",
            "S社株式",
            "買掛金",
            "売上原価"
        ]
    },
    {
        "id": 178,
        "number": 2,
        "subNumber": 1,
        "categoryId": 56,
        "content": "TO社はS社の発行済株式の60％を所有している。連結会社間（TO社とS社）の取引高と債権債務残高は次のとおりである。<br> 【TO社からS社】<br> 受取利息20円、貸付金40円<br> 【S社からTO社】<br> 支払利息20円、借入金40円",
        "lecture": "",
        "shiwakeLeftAnswer": "受取利息:20  借入金:40",
        "shiwakeRightAnswer": "支払利息:20  貸付金:40",
        "kamokus": [
            "貸付金",
            "売上高",
            "借入金",
            "受取利息",
            "売上原価",
            "支払利息"
        ]
    },
    {
        "id": 179,
        "number": 1,
        "subNumber": 1,
        "categoryId": 57,
        "content": "TO社はS社の発行済株式の60％を所有している。当期においてTO社は、S社振出の約束手形100円を銀行で割り引いている（割引料は0円）。",
        "lecture": "",
        "shiwakeLeftAnswer": "支払手形:100",
        "shiwakeRightAnswer": "短期借入金:100",
        "kamokus": [
            "受取手形",
            "手形売却損",
            "短期借入金",
            "支払手数料",
            "支払手形",
            "非支配株主持分"
        ]
    },
    {
        "id": 180,
        "number": 1,
        "subNumber": 1,
        "categoryId": 58,
        "content": "TO社はS社の発行済株式の60％を所有している。当期末におけるTO社の売掛金残高のうち100円はS社に対するものである。TO社は売掛金に対して5％の貸倒引当金を設定している。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100  貸倒引当金:5",
        "shiwakeRightAnswer": "売掛金:100  貸倒引当金繰入:5",
        "kamokus": [
            "非支配株主持分",
            "売掛金",
            "非支配株主に帰属する当期純利益",
            "貸倒引当金繰入",
            "買掛金",
            "貸倒引当金"
        ]
    },
    {
        "id": 181,
        "number": 2,
        "subNumber": 1,
        "categoryId": 58,
        "content": "TO社はS社の発行済株式の60％を所有している。当期末におけるS社の売掛金残高のうち100円はTO社に対するものである。S社は売掛金に対して5％の貸倒引当金を設定している。",
        "lecture": "",
        "shiwakeLeftAnswer": "買掛金:100  貸倒引当金:5  非支配株主に帰属する当期純利益:2",
        "shiwakeRightAnswer": "売掛金:100  貸倒引当金繰入:5  非支配株主持分:2",
        "kamokus": [
            "非支配株主に帰属する当期純利益",
            "貸倒引当金繰入",
            "非支配株主持分",
            "売掛金",
            "貸倒引当金",
            "買掛金"
        ]
    },
    {
        "id": 182,
        "number": 1,
        "subNumber": 1,
        "categoryId": 59,
        "content": "TO社はS社の発行済株式の60％を所有している。TO社はS社に対して原価に20％の利益を加算して商品を販売している。S社の期末商品棚卸高のうち120円はTO社から仕入れたものである。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上原価:20",
        "shiwakeRightAnswer": "商品:20",
        "kamokus": [
            "非支配株主持分",
            "売上高",
            "S社株式",
            "商品",
            "非支配株主に帰属する当期純利益",
            "売上原価"
        ]
    },
    {
        "id": 183,
        "number": 2,
        "subNumber": 1,
        "categoryId": 59,
        "content": "TO社はS社の発行済株式の60％を所有している。S社はTO社に対して原価に20％の利益を加算して商品を販売している。TO社の期末商品棚卸高のうち120円はS社から仕入れたものである。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上原価:20  非支配株主持分:8",
        "shiwakeRightAnswer": "商品:20  非支配株主に帰属する当期純利益:8",
        "kamokus": [
            "売上高",
            "利益剰余金",
            "非支配株主に帰属する当期純利益",
            "売上原価",
            "非支配株主持分",
            "商品"
        ]
    },
    {
        "id": 184,
        "number": 3,
        "subNumber": 1,
        "categoryId": 59,
        "content": "TO社はS社の発行済株式の60％を所有している。TO社はS社に対して原価に20％の利益を加算して商品を販売している。S社の期首商品棚卸高と期末商品棚卸高のうちTO社から仕入れたものはそれぞれ120円と240円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "利益剰余金:20  商品:20  売上原価:40",
        "shiwakeRightAnswer": "商品:20  売上原価:20  商品:40",
        "kamokus": [
            "売上原価",
            "非支配株主持分",
            "売上高",
            "商品",
            "非支配株主に帰属する当期純利益",
            "利益剰余金"
        ]
    },
    {
        "id": 185,
        "number": 1,
        "subNumber": 1,
        "categoryId": 60,
        "content": "TO社はS社の発行済株式の60％を所有している。TO社はS社に対して帳簿価額500円の土地を550円で売却しており、S社は当期末においてこの土地を保有している。",
        "lecture": "",
        "shiwakeLeftAnswer": "固定資産売却益:50",
        "shiwakeRightAnswer": "土地:50",
        "kamokus": [
            "非支配株主に帰属する当期純利益",
            "S社株式",
            "土地",
            "非支配株主持分",
            "資本金",
            "固定資産売却益"
        ]
    },
    {
        "id": 186,
        "number": 2,
        "subNumber": 1,
        "categoryId": 60,
        "content": "TO社はS社の発行済株式の60％を所有している。S社はTO社に対して帳簿価額500円の土地を550円で売却しており、TO社は当期末においてこの土地を保有している。",
        "lecture": "",
        "shiwakeLeftAnswer": "固定資産売却益:50  非支配株主持分:20",
        "shiwakeRightAnswer": "土地:50  非支配株主に帰属する当期純利益:20",
        "kamokus": [
            "固定資産売却益",
            "非支配株主に帰属する当期純利益",
            "売上原価",
            "商品",
            "非支配株主持分",
            "土地"
        ]
    },
    {
        "id": 187,
        "number": 1,
        "subNumber": 1,
        "categoryId": 61,
        "content": "材料10kg（＠100円）を掛けで仕入れた。なお、引取運賃50円は現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料:1050",
        "shiwakeRightAnswer": "買掛金:1000  現金:50",
        "kamokus": [
            "現金",
            "発送費",
            "未払金",
            "材料",
            "仕掛品",
            "買掛金"
        ]
    },
    {
        "id": 188,
        "number": 2,
        "subNumber": 1,
        "categoryId": 61,
        "content": "材料100円を消費した。このうち80円が直接材料費、20円が間接材料費である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:80  製造間接費:20",
        "shiwakeRightAnswer": "材料:100",
        "kamokus": [
            "買掛金",
            "製造間接費",
            "材料副費",
            "現金",
            "材料",
            "仕掛品"
        ]
    },
    {
        "id": 189,
        "number": 1,
        "subNumber": 1,
        "categoryId": 62,
        "content": "月末における材料の帳簿棚卸数量は15kg（消費単価は＠12円）であるが、実地棚卸数量は12kgであった。",
        "lecture": "",
        "shiwakeLeftAnswer": "製造間接費:36",
        "shiwakeRightAnswer": "材料:36",
        "kamokus": [
            "材料副費",
            "買掛金",
            "現金",
            "材料",
            "仕掛品",
            "製造間接費"
        ]
    },
    {
        "id": 190,
        "number": 1,
        "subNumber": 1,
        "categoryId": 63,
        "content": "直接材料として材料35kgを消費した。なお、予定消費単価は＠10円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:350",
        "shiwakeRightAnswer": "材料:350",
        "kamokus": [
            "材料",
            "製造間接費",
            "買掛金",
            "材料副費",
            "現金",
            "仕掛品"
        ]
    },
    {
        "id": 191,
        "number": 2,
        "subNumber": 1,
        "categoryId": 63,
        "content": "当月の直接材料費の実際消費額は420円であった。なお、予定消費額は350円で計上している。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料消費価格差異:70",
        "shiwakeRightAnswer": "材料:70",
        "kamokus": [
            "材料副費差異",
            "材料",
            "売上原価",
            "仕掛品",
            "材料消費価格差異",
            "製品"
        ]
    },
    {
        "id": 192,
        "number": 3,
        "subNumber": 1,
        "categoryId": 63,
        "content": "当月の直接材料費の実際消費額は300円であった。なお、予定消費額は350円で計上している。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料:50",
        "shiwakeRightAnswer": "材料消費価格差異:50",
        "kamokus": [
            "材料消費価格差異",
            "売上原価",
            "製品",
            "買掛金",
            "材料",
            "仕掛品"
        ]
    },
    {
        "id": 193,
        "number": 4,
        "subNumber": 1,
        "categoryId": 63,
        "content": "材料消費価格差異勘定の借方残高70円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上原価:70",
        "shiwakeRightAnswer": "材料消費価格差異:70",
        "kamokus": [
            "売上原価",
            "材料",
            "買掛金",
            "製造間接費",
            "材料副費差異",
            "材料消費価格差異"
        ]
    },
    {
        "id": 194,
        "number": 5,
        "subNumber": 1,
        "categoryId": 63,
        "content": "材料消費価格差異勘定の貸方残高50円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料消費価格差異:50",
        "shiwakeRightAnswer": "売上原価:50",
        "kamokus": [
            "材料消費価格差異",
            "製造間接費",
            "仕掛品",
            "製品",
            "売上原価",
            "材料"
        ]
    },
    {
        "id": 195,
        "number": 1,
        "subNumber": 1,
        "categoryId": 64,
        "content": "材料100円を掛けで購入した。なお、購入代価に対して10％の材料副費を予定配賦している。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料:110",
        "shiwakeRightAnswer": "買掛金:100  材料副費:10",
        "kamokus": [
            "材料副費",
            "未払金",
            "材料消費価格差異",
            "仕掛品",
            "材料",
            "買掛金"
        ]
    },
    {
        "id": 196,
        "number": 2,
        "subNumber": 1,
        "categoryId": 64,
        "content": "当月の材料副費の実際発生額は12円であった。なお、予定配賦額は10円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料副費差異:2",
        "shiwakeRightAnswer": "材料副費:2",
        "kamokus": [
            "材料",
            "材料消費価格差異",
            "買掛金",
            "材料副費",
            "仕掛品",
            "材料副費差異"
        ]
    },
    {
        "id": 197,
        "number": 3,
        "subNumber": 1,
        "categoryId": 64,
        "content": "材料副費差異勘定の借方残高2円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上原価:2",
        "shiwakeRightAnswer": "材料副費差異:2",
        "kamokus": [
            "買掛金",
            "仕掛品",
            "材料",
            "売上原価",
            "材料副費差異",
            "材料副費"
        ]
    },
    {
        "id": 198,
        "number": 1,
        "subNumber": 1,
        "categoryId": 65,
        "content": "当月の賃金支給額100円から源泉所得税10円を差し引いた残額を当座預金口座から支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "賃金:100",
        "shiwakeRightAnswer": "預り金:10  当座預金:90",
        "kamokus": [
            "当座預金",
            "製造間接費",
            "仕掛品",
            "預り金",
            "買掛金",
            "賃金"
        ]
    },
    {
        "id": 199,
        "number": 2,
        "subNumber": 1,
        "categoryId": 65,
        "content": "当月の直接工の賃金消費額は132円、作業時間は12時間（直接作業時間10時間、間接作業時間2時間）であった。なお、間接工の賃金消費額は30円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:110  製造間接費:52",
        "shiwakeRightAnswer": "賃金:162",
        "kamokus": [
            "仕掛品",
            "預り金",
            "賃金",
            "当座預金",
            "材料",
            "製造間接費"
        ]
    },
    {
        "id": 200,
        "number": 1,
        "subNumber": 1,
        "categoryId": 66,
        "content": "直接工の直接作業時間は10時間であった。直接工の賃金消費額は予定賃率＠10円を用いて計算する。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:100",
        "shiwakeRightAnswer": "賃金:100",
        "kamokus": [
            "賃金",
            "製造間接費",
            "普通預金",
            "賃率差異",
            "仕掛品",
            "預り金"
        ]
    },
    {
        "id": 201,
        "number": 2,
        "subNumber": 1,
        "categoryId": 66,
        "content": "当月の直接工の賃金実際消費額は110円であった。なお、予定消費額は100円で計上している。",
        "lecture": "",
        "shiwakeLeftAnswer": "賃率差異:10",
        "shiwakeRightAnswer": "賃金:10",
        "kamokus": [
            "製造間接費",
            "仕掛品",
            "賃金",
            "預り金",
            "買掛金",
            "賃率差異"
        ]
    },
    {
        "id": 202,
        "number": 3,
        "subNumber": 1,
        "categoryId": 66,
        "content": "当月の直接工の賃金実際消費額は95円であった。なお、予定消費額は100円で計上している。",
        "lecture": "",
        "shiwakeLeftAnswer": "賃金:5",
        "shiwakeRightAnswer": "賃率差異:5",
        "kamokus": [
            "売上原価",
            "賃率差異",
            "仕掛品",
            "賃金",
            "製造間接費",
            "製品"
        ]
    },
    {
        "id": 203,
        "number": 4,
        "subNumber": 1,
        "categoryId": 66,
        "content": "賃率差異勘定の借方残高10円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上原価:10",
        "shiwakeRightAnswer": "賃率差異:10",
        "kamokus": [
            "賃金",
            "材料消費価格差異",
            "製造間接費",
            "賃率差異",
            "仕掛品",
            "売上原価"
        ]
    },
    {
        "id": 204,
        "number": 5,
        "subNumber": 1,
        "categoryId": 66,
        "content": "賃率差異勘定の貸方残高5円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "賃率差異:5",
        "shiwakeRightAnswer": "売上原価:5",
        "kamokus": [
            "仕掛品",
            "売上原価",
            "賃金",
            "普通預金",
            "製造間接費",
            "賃率差異"
        ]
    },
    {
        "id": 205,
        "number": 1,
        "subNumber": 1,
        "categoryId": 67,
        "content": "当月の外注加工賃100円を現金で支払った。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:100",
        "shiwakeRightAnswer": "現金:100",
        "kamokus": [
            "製造間接費",
            "材料",
            "売上原価",
            "現金",
            "買掛金",
            "仕掛品"
        ]
    },
    {
        "id": 206,
        "number": 2,
        "subNumber": 1,
        "categoryId": 67,
        "content": "当月の工場建物減価償却費を計上する。なお、1年間の減価償却費は120円である。",
        "lecture": "",
        "shiwakeLeftAnswer": "製造間接費:10",
        "shiwakeRightAnswer": "建物減価償却累計額:10",
        "kamokus": [
            "工場",
            "仕掛品",
            "製造間接費",
            "製品",
            "売上原価",
            "建物減価償却累計額"
        ]
    },
    {
        "id": 207,
        "number": 3,
        "subNumber": 1,
        "categoryId": 67,
        "content": "材料棚卸減耗費20円が発生した。",
        "lecture": "",
        "shiwakeLeftAnswer": "製造間接費:20",
        "shiwakeRightAnswer": "材料:20",
        "kamokus": [
            "材料消費価格差異",
            "材料副費",
            "仕掛品",
            "売上原価",
            "製造間接費",
            "材料"
        ]
    },
    {
        "id": 208,
        "number": 1,
        "subNumber": 1,
        "categoryId": 68,
        "content": "製造間接費は直接作業時間を配賦基準として予定配賦率＠35円で各製造指図書に予定配賦する。当月の直接作業時間はNo.101は20時間、No.102は25時間、No.103は5時間であった。各製造指図書の予定配賦額を計算し、仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:1750",
        "shiwakeRightAnswer": "製造間接費:1750",
        "kamokus": [
            "製品",
            "売上原価",
            "賃金",
            "製造間接費",
            "普通預金",
            "仕掛品"
        ]
    },
    {
        "id": 209,
        "number": 2,
        "subNumber": 1,
        "categoryId": 68,
        "content": "当月の製造間接費の実際発生額は2,000円であった。なお、予定配賦額は1,750円で計上している。",
        "lecture": "",
        "shiwakeLeftAnswer": "製造間接費配賦差異:250",
        "shiwakeRightAnswer": "製造間接費:250",
        "kamokus": [
            "仕掛品",
            "製品",
            "売上原価",
            "建物減価償却累計額",
            "製造間接費",
            "製造間接費配賦差異"
        ]
    },
    {
        "id": 210,
        "number": 3,
        "subNumber": 1,
        "categoryId": 68,
        "content": "当月の製造間接費の実際発生額は1,700円であった。なお、予定配賦額は1,750円で計上している。",
        "lecture": "",
        "shiwakeLeftAnswer": "製造間接費:50",
        "shiwakeRightAnswer": "製造間接費配賦差異:50",
        "kamokus": [
            "製品",
            "工場",
            "仕掛品",
            "製造間接費配賦差異",
            "売上原価",
            "製造間接費"
        ]
    },
    {
        "id": 211,
        "number": 4,
        "subNumber": 1,
        "categoryId": 68,
        "content": "製造間接費配賦差異勘定の借方残高250円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "売上原価:250",
        "shiwakeRightAnswer": "製造間接費配賦差異:250",
        "kamokus": [
            "仕掛品",
            "建物減価償却累計額",
            "製造間接費配賦差異",
            "賃率差異",
            "製造間接費",
            "売上原価"
        ]
    },
    {
        "id": 212,
        "number": 5,
        "subNumber": 1,
        "categoryId": 68,
        "content": "製造間接費配賦差異勘定の貸方残高50円を売上原価勘定に振り替える。",
        "lecture": "",
        "shiwakeLeftAnswer": "製造間接費配賦差異:50",
        "shiwakeRightAnswer": "売上原価:50",
        "kamokus": [
            "材料",
            "仕掛品",
            "製造間接費",
            "売上原価",
            "製品",
            "製造間接費配賦差異"
        ]
    },
    {
        "id": 213,
        "number": 1,
        "subNumber": 1,
        "categoryId": 69,
        "content": "本社で材料100円を掛けで購入し、工場の倉庫に送付した。本社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "工場:100",
        "shiwakeRightAnswer": "買掛金:100",
        "kamokus": [
            "本社",
            "支店",
            "本店",
            "買掛金",
            "工場",
            "未払金"
        ]
    },
    {
        "id": 214,
        "number": 2,
        "subNumber": 1,
        "categoryId": 69,
        "content": "本社で材料100円を掛けで購入し、工場の倉庫に送付した。工場の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "材料:100",
        "shiwakeRightAnswer": "本社:100",
        "kamokus": [
            "工場",
            "本店",
            "材料",
            "製造間接費",
            "仕掛品",
            "本社"
        ]
    },
    {
        "id": 215,
        "number": 3,
        "subNumber": 1,
        "categoryId": 69,
        "content": "工場で材料60円（直接材料40円、間接材料20円）を消費した。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:40  製造間接費:20",
        "shiwakeRightAnswer": "材料:60",
        "kamokus": [
            "売上原価",
            "製造間接費",
            "工場",
            "材料",
            "本社",
            "仕掛品"
        ]
    },
    {
        "id": 216,
        "number": 4,
        "subNumber": 1,
        "categoryId": 69,
        "content": "製品80円が完成した。",
        "lecture": "",
        "shiwakeLeftAnswer": "製品:80",
        "shiwakeRightAnswer": "仕掛品:80",
        "kamokus": [
            "買掛金",
            "材料",
            "仕掛品",
            "製造間接費",
            "製品",
            "売上原価"
        ]
    },
    {
        "id": 217,
        "number": 5,
        "subNumber": 1,
        "categoryId": 69,
        "content": "本社は得意先に製品110円を掛けで売り上げ、本社の指示で工場は原価80円の製品を得意先に送付した。本社の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "売掛金:110  売上原価:80",
        "shiwakeRightAnswer": "売上:110  工場:80",
        "kamokus": [
            "工場",
            "支店",
            "売上",
            "売上原価",
            "売掛金",
            "買掛金"
        ]
    },
    {
        "id": 218,
        "number": 6,
        "subNumber": 1,
        "categoryId": 69,
        "content": "本社は得意先に製品110円を掛けで売り上げ、本社の指示で工場は原価80円の製品を得意先に送付した。工場の仕訳を示しなさい。",
        "lecture": "",
        "shiwakeLeftAnswer": "本社:80",
        "shiwakeRightAnswer": "製品:80",
        "kamokus": [
            "本店",
            "工場",
            "製造間接費",
            "製品",
            "仕掛品",
            "本社"
        ]
    },
    {
        "id": 219,
        "number": 1,
        "subNumber": 1,
        "categoryId": 70,
        "content": "材料勘定から仕掛品勘定に振り替える仕訳をしなさい。なお、当工場ではパーシャル・プランにより記帳しており、当月の投入量は50個、標準直接材料費は1個あたり20円、実際直接材料費は1,092円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:1092",
        "shiwakeRightAnswer": "材料:1092",
        "kamokus": [
            "買掛金",
            "製造間接費",
            "売上原価",
            "材料",
            "製品",
            "仕掛品"
        ]
    },
    {
        "id": 220,
        "number": 2,
        "subNumber": 1,
        "categoryId": 70,
        "content": "材料勘定から仕掛品勘定に振り替える仕訳をしなさい。なお、当工場ではシングル・プランにより記帳しており、当月の投入量は50個、標準直接材料費は1個あたり20円、実際直接材料費は1,092円であった。",
        "lecture": "",
        "shiwakeLeftAnswer": "仕掛品:1000",
        "shiwakeRightAnswer": "材料:1000",
        "kamokus": [
            "製造間接費",
            "売上原価",
            "仕掛品",
            "材料副費",
            "買掛金",
            "材料"
        ]
    }
]
}